import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import LZString from 'lz-string';
import { useTranslation } from 'react-i18next';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';

//! CONSTANTS VARIBALE
import {
  UTAG_DATA,
  TOP_OPTIONS,
  SOURCE_PART,
  TOP_OPTIONS_UNLOGGED,
  COL_DEF_SORT_FILTER_PARTSTATUS_ON,
  LOCALE,
  NON_DIGIKEY,
  COL_DEF_SET_PINED_LEFT_COL,
  COL_DEF_UN_SET_PINED_COL,
  COL_DEF_SET_PINED_RIGHT_COL,
  EXECL_STYLE
} from '../../constants';

// ! UTILS TABLE
import {
  convertSourcePartDetail,
  getAdditionalData,
  populateMediaLink,
  validateProducDetail,
  getColumns,
  sortTableData,
  getHeadersOfParameters,
  useGetColumnDefs,
  updateColDefs,
  chooseSourcePart,
  defaultSortCrossTypeData,
  getAdditionalDataUnLogged,
  getColumnsUnLogged,
  wrapReturnStringForUnitTest,
  updateUrlUtil,
  resetSearchRequest,
  updateColDefsUniqueByFieldName,
  removeDuplicates,
  createOrUpdateKeyState,
  restoreState,
  getLangSite,
  addCellRenderForPinColumn,
  setSelectedPartAndUpdateIntoUrl,
  restorePartSelected,
  redirectToComparePage,
  restorePartSelectedWhenReturningFromComparePage
} from '../../ultils';

// ! MODELS
import { ISubstitute, ICrossPart } from '../../models/CrossPartDetails';
import { IProductDetails } from '../../models/ProductDetails';
import { IProductDetailById, IProductVariation } from '../../models/ProductDetailById';
import { ISearchQueryRequest } from '../../models/ISearchQueryRequest';

// ! CAL API
import {
  getCrossPartDetails,
  getProductDetails,
  getNonDKPartCross,
  createShortUrl,
  getUrlById,
  getTariffFunctionFlag
} from '../../services';

// ! COMPONENTS
import { frameworkComponents } from '../../components/cell-render';
import TopSearch from '../../components/top-search';
import Utag from '../../components/utag';
import AppliedFilter from '../../components/applied-filter';
import { Introduction } from '../../components/introduction';
import { SpinnerForTable } from '../../components/spinner';
import { ReverseAgTable } from '../../components/reverse-ag-table';
import WarningMessageContainer from '../../components/warning-message-container';
import ShareModal from '../../components/share-modal';
import ExactMatch from '../../components/exact-match';
import AppInfo from '../../components/app-info';
import ToggleSwitch from '../../components/toggle-switch';
import ActionWhenSelectPart from '../../components/action-when-select-part';
import ActionWhenSelectPartHasMyList from '../../components/action-when-select-part-has-my-list';
import ExportToExcel from '../../components/export-to-excel';
import CrossTitleFeedback from '../../components/cross-title-feedback';
import BottomSearch from '../../components/bottom-search';

// ! HOOKS
import useDragColumnChange from '../../hooks/useDragColumnChange';
import useResizeGrid from '../../hooks/useResizeGrid';
import useSticky from '../../hooks/useSticky';
import { useInitSearchQueryRequest } from '../../hooks/useInitSearchQueryRequest';
import { useUpdateResultAndQueryString } from '../../hooks/useUpdateResultAndQueryString';
import useActiveStateTabHeader from '../../hooks/useActiveStateTabHeader';
import useSetCssForAggridTable from '../../hooks/useSetCssForAggridTable';
import useToggleDisplayForSpinner from '../../hooks/useToggleDisplayForSpinner';
import useRefEventForTagging from '../../hooks/useRefEventForTagging';
import { useUpdateAttributeByQuery } from '../../hooks/useUpdateAttributeByQuery/useUpdateAttributeByQuery';

// ! CONTEXT
import { AuthContext } from '../../context/UserContext';
import { UtagContext } from '../../context/UtagContext';
import { TabContext } from '../../context/tabContext';
import { IUtag } from '../../models/IUtag';

// ! RECOIL
import searchRequestAtom from '../../recoils/useSearchRequest/searchRequestAtom';
import selectedCheckboxsAtom from '../../recoils/useSelectedCheckboxsReverseSearch/selectedCheckboxsAtom';
import reverseResultAtom from '../../recoils/useReverseResult/reverseResultAtom';
import selectedDataAtom from '../../recoils/useSelectedData/selectedDataAtom';
import { callFunctionDkView, callGTMAnalytics } from '../../helper/analyticsTag';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';
import isUsingLocalStoredAtom from '../../recoils/useIsUsingLocalStored/IsUsingLocalStoredAtom';
import BreadcrumbLists from '../../components/bread-crumb-lists';
import { pinnedSelectionState } from '../../recoils/usePinnedSelection/isPinnedSelectionAtom';

const LandingPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  //ReverseSearch - Link share
  //Global state
  const [searchRequest, setSearchRequest] = useRecoilState(searchRequestAtom);
  const [, setReverseResult] = useRecoilState(reverseResultAtom);
  const [listCheckBox, setListCheckbox] = useRecoilState(selectedCheckboxsAtom);
  const [pinnedSelected] = useRecoilState(pinnedSelectionState);
  const setPinnedSelected = useSetRecoilState(pinnedSelectionState);
  //
  const [reverseSearchedProduct, setReverseSearchedProduct] = useState<any>();
  //utag begin
  const utagContext = useContext(UtagContext);
  const [searchTemp, setSearchTemp] = useState<string>('');
  const setIsUsingLocalStoraged = useSetRecoilState(isUsingLocalStoredAtom);
  //close

  // ! state check user login
  const { userData } = useContext(AuthContext);
  // get column from util
  const columnDefs = useGetColumnDefs(userData.IsLoggedIn)

  const [inputError, setInputError] = useState<string>('');
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const [isNoCrossesFound, setIsNoCrossesFound] = useState<boolean>(false);
  const [isNoResult, setIsNoResult] = useState<boolean>(false);
  const [isNoProductFound, setIsNoProductFound] = useState<boolean>(false);
  const [tableData, setTableData] = useState<ISubstitute[]>([]);
  const [uTagData, setUTagData] = useState<IUtag>(UTAG_DATA.utagData);
  const [isSearchByUrl, setIsSearchByUrl] = useState<boolean>(true);
  const [isCompareProducts, setIsCompareProducts] = useState<boolean>(false);
  const [isCompareProductsView, setIsCompareProductsView] =
    useState<boolean>(false);
  const [numberOfResult, setNumberOfResult] = useState<number>(0);
  const [columns, setColumns] = useState<any>(columnDefs);
  const columnApiRef = useRef<any>(null);
  const gridApiRef = useRef<any>(null);
  const pinnedSelectedRef = useRef(pinnedSelected);
  //Table ui states
  const sourcePartCellRef = useRef<any>();
  const sourcePartCellMobileRef = useRef<any>();
  const [numberOfSelected, setNumberOfSelected] = useState<number>(0);
  const [gridHeight, setGridHeight] = useState<number>(0);
  const [scriptAnalyticIsLoaded, setScriptAnalyticIsLoaded] =
    useState<boolean>(false);

  //Part filter states
  const [isDisplayOptionApplied, setIsDisplayOptionApplied] =
    useState<boolean>(false);
  const [isMarketplaceApplied, setIsMarketplaceApplied] =
    useState<boolean>(false);
  const [isExcludeTariffApplied, setIsExcludeTariffApplied] = useState<boolean>(false);
  const [isStockingApplied, setIsStockingApplied] = useState<boolean>(false);
  const [isTariffActive, setIsTariffActive] = useState<boolean>(false);
  const [isTabCompareAtt, setIsTabCompareAtt] = useState<boolean>(true);

  const [sortCol, setSortCol] = useState<string>('');
  const [sortDirection, setSortDirection] = useState<string>('');
  const [filter, setFilter] = useState<string>('');
  const [isModalOpen, setModalState] = useState(false);
  const [urlPageNumber, setURLPageNumber] = useState<number>(0);
  const toggleModal = () => setModalState(!isModalOpen);
  const [productDetail, setProductDetail] = useState<IProductDetailById[]>([]);
  const [nonDigikeyProduct, setNonDigikeyProduct] = useState<
    IProductDetailById[]
  >([]);
  const [defaultExactProd, setDefaultExactProd] = useState<number>(0);

  const [vendorName, setVendorName] = useState<string>();
  const [isMultipleProducts, setIsMultipleProducts] = useState<boolean>(false);

  // ! state url
  const [currentUrl, setCurrentUrl] = useState<string>('');
  const [shortUrl, setShortUrl] = useState<string>('');
  const [urlParams, setUrlParams] = useState<URLSearchParams>();
  const pageNumberRef = useRef<number>(0);
  const urlRef = useRef<string>('');
  const isCompareRef = useRef<string>('false');
  const appliedFiltersToReturnRef = useRef<any>();
  const filterToReturnRef = useRef<any>();
  const [appliedFilters, setAppliedFilters] = useState<string[]>([]);
  const [checkFetchedUser, setCheckFetchedUser] = useState<boolean>();

  // ! for tab
  const { tabId, setTabId } = useContext(TabContext);
  const [showTabHeader, setShowTabHeader] = useState<boolean>(true);
  const isDefaultReverseViewRef = useRef<boolean>(false);
  const tabIdRef = useRef<any>('');
  // const [pinNum, setPinNum] = useState<number>(0);
  const [originalTableCol, setOriginalTableCol] = useState<any>();
  const [originalCompareCols, setOriginalCompareCols] = useState<any>();
  const [originalBasePartCols, setOriginalBasePartCols] = useState<any>();
  const [originalPinOutsCols, setOriginalPinOutsCols] = useState<any>();
  const originalPinOutsColsRef = useRef<any>()

  // ! for BASEPART, PINOUT state starts
  const [haveBasePart, setHaveBasePart] = useState<boolean>(false);
  const [havePinOuts, setHavePinOuts] = useState<boolean>(false);

  const [currentColDefs, setCurrentColDefs] = useState<any>(null);
  const [unitPriceURL, setUnitPriceURL] = useState<number>(0);
  const [partIdURL, setPartIdURL] = useState<number>(0);
  const [pimNumberUrl, setPimNumberURL] = useState<string>('');
  const [searchedProduct, setSearchedProduct] = useState<any>();
  const [isNonDk, setIsNonDk] = useState<boolean>(false);
  // ! for basePart state ends

  // !table base part
  const tableBasepartef = useRef<any>();
  const tableTempBasePartRef = useRef<any>();
  // !table not base part
  const tableTempRef = useRef<any>();

  // ! multi vendor
  const idOfMoreVendor = useRef<string>();
  const unitPriceOfMoreVendor = useRef<string>();
  const pimVariantNumberOfMoreVendor = useRef<string>();
  const [isClickProductHasMultiVendor, setIsClickProductHasMultiVendor] =
    useState<boolean>(false);

  const [isReturnToView, setIsReturnToView] = useState<boolean>(false);

  // ! screen width
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // ! Check if country is israel
  const [isReverse, setIsReverse] = useState<boolean>(false);
  const searchQueryRef = useRef<string>('');
  const isCallingApi = useRef<boolean>(false);
  const checkboxTypeRef = useRef<string[]>([]);
  const [productVariations, setProductVariations] = useState<IProductVariation[]>()


  // ! for language
  const { t } = useTranslation();

  const gridOptionsLocale = {
    localeTextFunc: (key: string, defaultValue: string) =>
      t(LOCALE[key]) || defaultValue
  };

  const langRef = useRef<string>();
  const siteRef = useRef<string>();
  const currRef = useRef<string>();
  // ! fix bug duplicate cross
  const [isNoCrossesFoundAtCompareTab, setIsNoCrossesFoundAtCompareTab] =
    useState<boolean>(false);
  const searchedProductTempref = useRef<ISubstitute[]>();
  const [columnDefsFilterGlobal, setcolumnDefsFilterGlobal] =
    useState<any>(columnDefs);

  // ! For Save State To LocalStorage Starts
  const colStagesDefaultRef = useRef<any>();
  const [isOrderByColumn, setIsOrderByColumn] = useState<boolean>(false);
  const isOrderByColumnRef = useRef<boolean>(false);
  const isOrderByColumnFirstLoad = useRef<boolean>(false);
  // ! For Save State To LocalStorage ends

  const pageNumberToPinSourceRef = useRef<any>();

  const [isHorizontalView, setIsHorizontalView] = useState<boolean>(false);

  const sourcePartRowRef = useRef<any>();
  const sourcePartRowHeightRef = useRef<any>();

  const [isAddToList, setIsAddToList] = useState<boolean>(false);

  const [selectedPartBeforeLogin, setSelectedPartBeforeLogin] = useState<any>();
  const [compareProductIds, setCompareProductIds] = useState<any>();

  const [selectedData, setSelectedData] = useRecoilState(selectedDataAtom);
  const [utagData,] = useRecoilState(utagObjectAtom);

  // ! For add part alternates MyList
  const [isHasMyList, setIsHasMyList] = useState<boolean>(false);
  const [listId, setListId] = useState<string>('');
  const [uniqueId, setUniqueId] = useState<string>('');

  useSticky(gridHeight);

  //Update source part row height
  useEffect(() => {
    sourcePartRowRef.current = document.querySelector('.ag-floating-top');
    sourcePartRowHeightRef.current = document.querySelector('.ag-row-level-0');

    try {
      if (
        sourcePartRowRef.current &&
        sourcePartRowHeightRef.current &&
        gridApiRef.current &&
        !gridApiRef.current.destroyCalled
      ) {
        const sourcePartRow = sourcePartRowRef.current;
        const sourcePartRowHeight = sourcePartRowHeightRef.current;

        const growHeight = gridApiRef.current.getPinnedTopRow(0)?.rowHeight + 0;
        if (sourcePartRow && sourcePartRowHeight) {
          sourcePartRow.style.minHeight = growHeight + 'px';
          sourcePartRow.style.height = growHeight + 'px';
        }
      }
    } catch { }
  });

  //Check the script utag is loaded
  useEffect(() => {
    if (!scriptAnalyticIsLoaded) {
      const tempScripts =
        document.querySelector(
          'script[src="//tags.tiqcdn.com/utag/digikey/main/prod/utag.js"]'
        ) ||
        document.querySelector(
          'script[src="//tags.tiqcdn.com/utag/digikey/main/qa/utag.js"]'
        ) ||
        document.querySelector(
          'script[src="//tags.tiqcdn.com/utag/digikey/main/dev/utag.js"]'
        );
      if (tempScripts) {
        setScriptAnalyticIsLoaded(true);
      }
    }
  });

  useEffect(() => {
    if (userData.wasFetched !== undefined) {
      setCheckFetchedUser(true);
    }
  }, [userData]);
  // ! for language and theme
  useEffect(() => {
    const langSiteObj = getLangSite('en');
    const body = document.body;

    siteRef.current = langSiteObj.site;
    langRef.current = langSiteObj.lang;
    currRef.current = langSiteObj.curr == null ? 'USD' : langSiteObj.curr;
    // ! Check if country is Israel
    if (siteRef.current === 'il' && langRef.current === 'he') {
      body.classList.add('rtl');
      setIsReverse(true);
    } else {
      body.classList.remove('rtl');
      setIsReverse(false);
    }

  }, [userData.IsLoggedIn]);

  //Update ref event for table sort,filter and paging
  useUpdateAttributeByQuery();

  // ! update partStatus Column for normal part
  const updatePartStatusColumn = (colDef: any) => {
    if (!isNoCrossesFound && !isNonDk &&
      gridApiRef.current && !gridApiRef.current.destroyCalled) {
      gridApiRef.current.setColumnDefs(
        updateColDefs(
          removeDuplicates(colDef, 'field'),
          COL_DEF_SORT_FILTER_PARTSTATUS_ON
        )
      );
    }
  };

  const checkDataHasTariff = (tabId: string) => {
    if (tabId === 'tabCompareAtt') {

      const checkCrossPartHasTariff = tableData.find(
        x => x.productVariations[0]?.priceBreaksIncludeTariff?.length > 0
      );
      const checkSourcePartHasTariff = searchedProduct && searchedProduct[0] && searchedProduct[0]?.productVariations && searchedProduct[0]?.productVariations[0]?.priceBreaksIncludeTariff?.length > 0

      //check if sourceData and crossData no tariff then hide column unit price tariff
      if (checkSourcePartHasTariff || checkCrossPartHasTariff) {
        return true;
      } else {
        return false;
      }
    }
  }

  // ! filter columns when change tab
  const filterColumnsHandler = () => {
    if (originalTableCol && originalTableCol.length > 0) {
      // get column for tab compare
      if (tabId === 'tabCompareAtt') {
        let tempCurrentColdDef = [...originalTableCol];
        const isHasTariff = checkDataHasTariff(tabId);
        if (!isHasTariff) {
          tempCurrentColdDef = [
            ...originalTableCol.filter(
              (item: any) =>
                (item && item.field && item.field !== 'priceBreaksIncludeTariff' && !item.field.startsWith('pin')) ||
                item.field === 'unitPrice'
            )
          ];
        }
        // if site is us and isTariffActive then show column unit price tariff
        else if (getLangSite('us').site === 'us' && isTariffActive) {
          tempCurrentColdDef = [
            ...originalTableCol.filter(
              (item: any) =>
                (item && item.field && !item.field.startsWith('pin')) ||
                item.field === 'unitPrice'
            )
          ];
        }
        else {
          tempCurrentColdDef = [
            ...originalTableCol.filter(
              (item: any) =>
                (item && item.field && item.field !== 'priceBreaksIncludeTariff' && !item.field.startsWith('pin')) ||
                item.field === 'unitPrice'
            )
          ];
        }

        if (screenWidth < 768) {
          const newColDefs = updateColDefsUniqueByFieldName(
            removeDuplicates(tempCurrentColdDef, 'field'),
            COL_DEF_UN_SET_PINED_COL,
            'manufacturerProductNumber'
          );
          setOriginalCompareCols(newColDefs);
        } else {
          const pinColumn = isReverse
            ? COL_DEF_SET_PINED_RIGHT_COL
            : COL_DEF_SET_PINED_LEFT_COL;
          const newColDefs = updateColDefsUniqueByFieldName(
            removeDuplicates(tempCurrentColdDef, 'field'),
            pinColumn,
            'manufacturerProductNumber'
          );
          setOriginalCompareCols(newColDefs);
        }
        updatePartStatusColumn(tempCurrentColdDef);
      }

      if (tabId === 'tabReverseLookup') {
        const tempCurrentColdDef = [
          ...originalTableCol.filter(
            (item: any) =>
              (item && item.field && item.field !== 'priceBreaksIncludeTariff' && !item.field.startsWith('pin')) ||
              item.field === 'unitPrice'
          )
        ];

        if (screenWidth < 768) {
          const newColDefs = updateColDefsUniqueByFieldName(
            removeDuplicates(tempCurrentColdDef, 'field'),
            COL_DEF_UN_SET_PINED_COL,
            'manufacturerProductNumber'
          );
          setOriginalCompareCols(newColDefs);
        } else {
          const pinColumn = isReverse
            ? COL_DEF_SET_PINED_RIGHT_COL
            : COL_DEF_SET_PINED_LEFT_COL;
          const newColDefs = updateColDefsUniqueByFieldName(
            removeDuplicates(tempCurrentColdDef, 'field'),
            pinColumn,
            'manufacturerProductNumber'
          );
          setOriginalCompareCols(newColDefs);
        }
        updatePartStatusColumn(tempCurrentColdDef);
      }

      // ! reduant columns
      if (tabId === 'tabComparePinouts') {
        const tempCurrentColdDef = [
          ...originalTableCol.filter(
            (item: any) =>
              (item.field && item.field.startsWith('pin')) ||
              item.field === 'manufacturerProductNumber' ||
              item.field === 'unitPrice' ||
              item.field === 'quantityAvailable' ||
              item.field === 'partStatus' ||
              item.parameterId === 1989 ||
              item.field === 'supplier'
              || item.field === 'rohsStatus'
              || item.field === 'primaryDatasheetUrl'
              || item.field === 'catalogDescription'
              || item.field === 'primaryPhotoUrl'
          )
        ];

        if (screenWidth < 768) {
          const newColDefs = updateColDefsUniqueByFieldName(
            removeDuplicates(tempCurrentColdDef, 'field'),
            COL_DEF_UN_SET_PINED_COL,
            'manufacturerProductNumber'
          );
          setOriginalPinOutsCols(newColDefs);
          originalPinOutsColsRef.current = newColDefs;
        } else {
          const pinColumn = isReverse
            ? COL_DEF_SET_PINED_RIGHT_COL
            : COL_DEF_SET_PINED_LEFT_COL;
          const newColDefs = updateColDefsUniqueByFieldName(
            removeDuplicates(tempCurrentColdDef, 'field'),
            pinColumn,
            'manufacturerProductNumber'
          );
          setOriginalPinOutsCols(newColDefs);
          originalPinOutsColsRef.current = newColDefs;
        }
        updatePartStatusColumn(tempCurrentColdDef);

        if (isNoCrossesFoundAtCompareTab) {
          const pinOutsColums = currentColDefs?.filter(
            (item: any) => item.isPinout === true
          );
          const columnMerge = tempCurrentColdDef.concat(pinOutsColums);
          const newColDefs = removeDuplicates(columnMerge, 'field')

          setOriginalPinOutsCols(newColDefs);
          originalPinOutsColsRef.current = newColDefs;

          updatePartStatusColumn(columnMerge);
        }
      }
    }
  };

  //! filter tab
  useEffect(() => {
    filterColumnsHandler();
  }, [originalTableCol, tabId, currentColDefs]);

  // ! resize table when have a little param
  useResizeGrid();

  // ! for tabHeader
  // ! UPDATED
  const getTabId = (tabIdInit: any) => {
    setPinnedSelected(false);
    const pinnedDiv = document.getElementById('pinnedTopRow');
    pinnedDiv?.classList.remove('ag-checked');
    setTabId(tabIdInit);
    isCallingApi.current = false;
    setIsError(false);
    setIsNoResult(false);
    isDefaultReverseViewRef.current = false;
    isOrderByColumnFirstLoad.current = false;
    let urlParamsSearch =
      urlRef.current === ''
        ? new URLSearchParams()
        : // !update currenturl
        new URLSearchParams(new URL('', urlRef.current).search);

    const decodedParameters = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(urlParamsSearch.get('s')!)
    );
    decodedParameters.set('isDefaultReverseView', 'false');
    setFilter('');
    decodedParameters.delete('filter');
    decodedParameters.delete('filterOrder');
    decodedParameters.delete('selectedDataIds')
    // check if tab is compare then enable checkbox exclude tariff
    if (tabIdInit === 'tabCompareAtt') {
      setIsTabCompareAtt(true);
    }
    else {
      let updateRequest = { ...searchRequest };
      setIsTabCompareAtt(false);
      setIsExcludeTariffApplied(false);
      decodedParameters.set('excludeTariffFilter', 'false');
      updateRequest = { ...updateRequest, excludeFilter: undefined };
      delete updateRequest.excludeFilter;
      setSearchRequest(updateRequest);
      externalFilterChanged("excludeTariffFilter", false)
    }
    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParameters.toString())}`
    );

    setNumberOfSelected(0);
    gridApiRef.current?.deselectAll();
    setSelectedData([]);
    setSelectedPartBeforeLogin([]);
    setCompareProductIds([]);
  };

  // !update url when tab change
  useEffect(() => {
    let urlParamsClickedTab =
      urlRef.current === ''
        ? new URLSearchParams()
        : new URLSearchParams(new URL('', urlRef.current).search);
    const decodedParameters = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(
        urlParamsClickedTab.get('s')!
      )
    );

    decodedParameters.set('tabId', tabId);

    if (isOrderByColumnFirstLoad.current) {
      setIsOrderByColumn(true);
    } else {
      setIsOrderByColumn(false);
      decodedParameters.delete('colStages');
      decodedParameters.delete('isOrderByColumn');
    }

    // !
    tabIdRef.current = tabId;

    // ! for save state to local storage starts
    const keyState = `${userData.CustomerId}_${searchQueryRef.current}_${siteRef.current}_${langRef.current}`;
    const keyTabState = `${userData.CustomerId}_${searchQueryRef.current}_${tabIdRef.current}_${siteRef.current}_${langRef.current}`;
    restoreState(
      keyState,
      columnApiRef.current,
      urlRef.current,
      userData.IsLoggedIn,
      searchRequest,
      keyTabState,
      tabIdRef.current,
      setIsDisplayOptionApplied,
      setIsMarketplaceApplied,
      setIsExcludeTariffApplied,
      setIsStockingApplied,
      setIsUsingLocalStoraged,
      updateUrl,
      setSearchRequest,
      externalFilterChanged
    );
    // ! for save state to local storage ends

    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParameters.toString())}`
    );

    // ! reset filter
    gridApiRef.current?.setFilterModel([]);
    setAppliedFilters([]);

    // ! reset sort
    columnApiRef.current?.applyColumnState({
      defaultState: { sort: null }
    });

    // !fix duplicate source
    if (isNoCrossesFoundAtCompareTab) {
      if (tabIdRef.current !== 'tabBasePart') {
        setIsNoCrossesFound(true);
        setIsNoResult(true);
        setSearchedProduct(null);
      } else {
        if (searchedProductTempref.current) {
          setSearchedProduct(searchedProductTempref.current);
        }
      }
    }
  }, [tabId, isNoCrossesFoundAtCompareTab]);

  // ! set param has pinout
  const updatePinOutsParam = (havePinOuts: string) => {
    let urlParamsRelatePinouts =
      urlRef.current === ''
        ? new URLSearchParams()
        : new URLSearchParams(new URL('', urlRef.current).search);
    const decodedParameters = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(
        urlParamsRelatePinouts.get('s')!
      )
    );
    decodedParameters.set('havePinOuts', havePinOuts);
    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParameters.toString())}`
    );
  };

  // ! screen width
  const setDimension = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', setDimension);

    // ! set header name belong to language
    columnDefs.forEach(function (colDef: any) {
      colDef.headerName = t(`xref-tbl-hd-${colDef.translateKey}`);
      // check if contains headerTooltip then show based on headerTooltip
      colDef.headerTooltip = colDef.tooltipField ? t(`xref-tbl-hd-${colDef.tooltipField}`) : t(`xref-tbl-hd-${colDef.translateKey}`);
    });
    return () => {
      window.removeEventListener('resize', setDimension);
    };
  }, [
    screenWidth,
    searchQuery,
    userData.IsLoggedIn,
    isNoProductFound,
    tableData,
    appliedFilters.length,
    isMultipleProducts,
    columnDefs
  ]);

  useEffect(() => {
    if (searchQuery) {
      setIsUsingLocalStoraged(true);
    }
  }, [searchQuery])

  useEffect(() => {
    const keyState = `${userData.CustomerId}_${searchQueryRef.current}_${siteRef.current}_${langRef.current}`;
    const keyTabState = `${userData.CustomerId}_${searchQueryRef.current}_${tabIdRef.current}_${siteRef.current}_${langRef.current}`;
    restoreState(
      keyState,
      columnApiRef.current,
      urlRef.current,
      userData.IsLoggedIn,
      searchRequest,
      keyTabState,
      tabIdRef.current,
      setIsDisplayOptionApplied,
      setIsMarketplaceApplied,
      setIsExcludeTariffApplied,
      setIsStockingApplied,
      setIsUsingLocalStoraged,
      updateUrl,
      setSearchRequest,
      externalFilterChanged
    );
  }, [isFetching, columnDefsFilterGlobal])

  useEffect(() => {
    if (
      wrapReturnStringForUnitTest(tabIdRef.current) !== 'tabBasePart' &&
      tableData &&
      tableData.length > 0
    ) {
      const havePinOuts = tableData.some((item: any) => item.pin1);
      setHavePinOuts(havePinOuts);
      updatePinOutsParam(havePinOuts.toString());
    } else {
      // !fix bug pinouts active tab
      let urlParamsPinOuts =
        urlRef.current === ''
          ? new URLSearchParams()
          : new URLSearchParams(new URL('', urlRef.current).search);
      const decodedParameters = new URLSearchParams(
        '?' +
        LZString.decompressFromEncodedURIComponent(urlParamsPinOuts.get('s')!)
      );

      const havePinOutsParam = decodedParameters.get('havePinOuts');
      // ! Check if has value at input when search
      if (havePinOutsParam === 'true' && !inputError) {
        setHavePinOuts(true);
      } else {
        setHavePinOuts(false);
      }
    }

    modifyUIAtComparePageHanlder(columns);
  }, [tableData, userData.IsLoggedIn]);

  // ! UPDATED
  // ! Load data when in share page and action 1 times
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (urlSearchParams.has('search') && urlSearchParams.has('listId') && urlSearchParams.has('uniqueId') && checkFetchedUser !== undefined && userData.IsLoggedIn && userData.CustomerId !== 0) {
      setIsHasMyList(true);
      setSearchQuery(urlSearchParams.get('search') ?? '');
      setListId(urlSearchParams.get('listId') ?? '');
      setUniqueId(urlSearchParams.get('uniqueId') ?? '');
      setIsDisplayOptionApplied(true);
      let updateRequest = { ...searchRequest };
      updateRequest = {
        ...updateRequest,
        productStatusFilter: [{ id: "0" }]

      };
      setSearchRequest(updateRequest);
      applyOptionHandler(true);
    }
    else if (urlSearchParams.has('search')) {
      if (checkFetchedUser !== undefined) {
        let decodedParameters: URLSearchParams = new URLSearchParams();
        const params = Array.from(urlSearchParams.entries());

        let partSearch = params[0][1];
        const partSearchKeyUrl = params[0][0];

        // ! Check url has part and key search
        if (partSearch && partSearchKeyUrl === 'search') {
          partSearch = partSearch.toUpperCase();
          decodedParameters.set('partSearch', partSearch.toString());
          setSearchQuery(partSearch);
        }
      }
    } else {
      //get params from short url
      if (checkFetchedUser !== undefined) {
        const path = window.location.pathname;
        if (isSearchByUrl) {
          const paths = path.split('/');
          const id = paths[paths.length - 1];
          const resultShortUrl = async () => {
            let url: string = '';

            // Use shortUrlId to get data
            if (path.includes('/cross-reference/')) {
              const res = await getUrlById(id);
              url = res.url;
            }

            // Use query string to get data
            if (window.location.href.includes('/cross-reference?s='))
              url = window.location.href;

            if (url) {
              const urlParamsNotInQueue = new URLSearchParams(new URL(url).search);

              setCurrentUrl(url)
              urlRef.current = url
              setUrlParams(urlParamsNotInQueue)

              if (urlParamsNotInQueue) {
                const decodedParameters = new URLSearchParams(
                  '?' +
                  LZString.decompressFromEncodedURIComponent(
                    urlParamsNotInQueue.get('s')!
                  )
                );

                // ! Get params by ref when state don't have
                const partId = decodedParameters.get('partId');
                const partUnitPrice = decodedParameters.get('partUnitPrice');
                const partPimNumber = decodedParameters.get('partPimNumber');
                const isCompareView = decodedParameters.get('isCompareView');
                const searchParam = decodedParameters.get('part');
                const tabIdParam = decodedParameters.get('tabId');
                //get productVariations from decode params and setState
                const productVariations = decodedParameters.get('productVariations');
                setProductVariations(productVariations ? JSON.parse(productVariations) : null);

                const searchRequestQuery: ISearchQueryRequest =
                  JSON.parse(decodedParameters.get('searchRequest') as string) ?? {};
                const listCheckbox: string[] = JSON.parse(
                  decodedParameters.get('checkboxList') as string
                );

                //set search request value when using share link
                if (Object.keys(searchRequestQuery).length > 0) {
                  setSearchRequest(searchRequestQuery);
                }

                //set list checkbox value when using share link
                if (listCheckbox) {
                  setListCheckbox([...listCheckbox]);
                }

                isCompareRef.current =
                  isCompareView !== null ? isCompareView : 'false';

                if (searchParam) {
                  let result;
                  searchQueryRef.current = searchParam;
                  // multip vendor
                  // ! Load data when tabId is not Basepart
                  if (partId && partUnitPrice && partPimNumber) {
                    //! Get choosen source part data by useRef
                    idOfMoreVendor.current = partId;
                    unitPriceOfMoreVendor.current = partUnitPrice;
                    pimVariantNumberOfMoreVendor.current = partPimNumber;

                    setIsFetching(true);

                    // ! Prevent show all part at copare page
                    if (isCompareRef.current !== 'true') {
                      isCallingApi.current = true;

                      //! Get multiple source parts data
                      await getPartData(searchParam, -1, -1, '', true);

                      //! Get choosen source part
                      setPartIdURL(parseInt(partId));
                      setUnitPriceURL(parseFloat(partUnitPrice));
                      setPimNumberURL(partPimNumber);

                      result = await getPartData(
                        searchParam,
                        parseInt(partId),
                        parseFloat(partUnitPrice),
                        partPimNumber,
                        true,
                        productVariations ? JSON.parse(productVariations) : null
                      );

                      result = defaultSortCrossTypeData(result, tabIdRef.current);

                      setTableData(result);
                    }
                    setIsFetching(false);
                  } else {
                    let result;
                    //! for improve load table starts
                    //! for basepart
                    //! prevent show all part at compare page
                    setIsFetching(true);
                    if (tabIdParam === 'tabBasePart') {
                      if (isCompareRef.current !== 'true') {
                        if (tableTempBasePartRef.current?.length > 0) {
                          setTableData(tableTempBasePartRef.current);
                        } else {
                          isCallingApi.current = true;
                          result = await getPartData(searchParam, -1, -1, '', true);
                          tableTempBasePartRef.current = result;
                          setTableData(result);
                        }
                      }

                      setIsNoCrossesFound(false);
                    } else {
                      if (isCompareRef.current !== 'true') {
                        //! fix part no cross has pin
                        if (tableTempRef.current?.length > 0) {
                          setTableData(tableTempRef.current);
                        } else {
                          isCallingApi.current = true;
                          result = await getPartData(searchParam, -1, -1, '', true);
                          result = defaultSortCrossTypeData(result, tabId);
                          tableTempRef.current = result;
                          setTableData(result);
                        }
                      }
                    }
                    setIsFetching(false);
                  }
                }
              }
            }
          };
          resultShortUrl();
          setIsSearchByUrl(false);
        }
      }
    }
  }, [checkFetchedUser]);

  // ! Update State Of Tab Header When Source Part Has
  useActiveStateTabHeader(
    havePinOuts,
    haveBasePart,
    showTabHeader,
    checkFetchedUser,
    reverseSearchedProduct,
    isFetching,
    inputError,
    isNoProductFound,
    isNoCrossesFound
  );

  useEffect(() => {
    let decodedParameters: URLSearchParams = new URLSearchParams();

    if (urlParams) {
      decodedParameters = new URLSearchParams(
        '?' + LZString.decompressFromEncodedURIComponent(urlParams.get('s')!)
      );

      const searchPartParam = decodedParameters.get('part');
      const sortColParam = decodedParameters.get('colId');
      const sortDirectionParam = decodedParameters.get('sort');
      const filterParam = decodedParameters.get('filter');
      const filterOrder = decodedParameters.get('filterOrder');
      const activeParam = decodedParameters.get('active');
      const marketplaceParam = decodedParameters.get('marketplace');
      const excludeTariffParam = decodedParameters.get('excludeTariffFilter');
      const stockingParam = decodedParameters.get('stocking');
      const pageNumberInUrl = decodedParameters.get('pageNumber');
      const tabIdParam = decodedParameters.get('tabId');
      const isOrderByColumn = decodedParameters.get('isOrderByColumn');
      const defaultReverseViewStatus = decodedParameters.get(
        'isDefaultReverseView'
      );
      const isHorizontalView = decodedParameters.get('isHorizontalView');
      const selectedDataIdsParam = decodedParameters.get('selectedDataIds');
      const compareProductIdsParams = decodedParameters.get('compareProductIds');

      if (defaultReverseViewStatus) {
        isDefaultReverseViewRef.current = defaultReverseViewStatus === 'true';
      }

      //SORT AND FILTER
      if (searchPartParam) {
        setSearchQuery(searchPartParam);
      }

      if (sortColParam && sortDirectionParam) {
        setSortCol(sortColParam);
        setSortDirection(sortDirectionParam);
      }

      if (filterParam) {
        setFilter(filterParam);
      }

      if (filterOrder) {
        setAppliedFilters(JSON.parse(filterOrder));
      }

      if (activeParam === 'true') {
        setIsDisplayOptionApplied(true);
        externalFilterChanged("activePartFilter", true)
      }

      if (marketplaceParam === 'true') {
        setIsMarketplaceApplied(true);
        externalFilterChanged("marketplaceFilter", true)
      }

      if (excludeTariffParam === 'true') {
        setIsExcludeTariffApplied(true);
        externalFilterChanged("excludeTariffFilter", true)
      }

      if (stockingParam === 'true') {
        setIsStockingApplied(true);
        externalFilterChanged("inStockingFilter", true)
      }

      if (pageNumberInUrl) {
        setURLPageNumber(parseInt(pageNumberInUrl));
      }

      if (tabIdParam) {
        setTabId(tabIdParam);
        if (tabIdParam !== "tabCompareAtt") {
          setIsTabCompareAtt(false);
        }
      }

      if (isOrderByColumn === 'true') {
        setIsOrderByColumn(true);
        isOrderByColumnFirstLoad.current = true;
      }

      if (isHorizontalView === 'true') {
        setIsHorizontalView(true);
      }

      if (selectedDataIdsParam) {
        const selectedDataIds = JSON.parse(selectedDataIdsParam);
        setSelectedPartBeforeLogin(selectedDataIds);
      }

      if (compareProductIdsParams) {
        const compareProductIds = JSON.parse(compareProductIdsParams);
        setCompareProductIds(compareProductIds);
      }
    }
  }, [urlParams]);

  // ! Set Css For Aggrid table
  useSetCssForAggridTable(isNoCrossesFound);

  useRefEventForTagging(
    {
      setIsSearchByUrl,
      setUTagData,
      tableData,
      searchQuery,
      searchTemp,
      isSearchByUrl,
      isFetching,
      isNoResult,
      isError,
      isNoCrossesFound,
      isNoProductFound,
      isMarketplaceApplied,
      isExcludeTariffApplied,
      isStockingApplied,
      isDisplayOptionApplied,
      haveBasePart,
      scriptAnalyticIsLoaded,
    },
    utagContext.refPageEvent,
    currentUrl,
    isMultipleProducts,
    gridApiRef.current?.getDisplayedRowCount()
  );

  //Set number of result if no crossesFound
  useEffect(() => {
    if (isNoCrossesFound) {
      setNumberOfResult(0);
    }
  }, [isNoCrossesFound]);

  useEffect(() => {
    if (isNoCrossesFoundAtCompareTab && isDefaultReverseViewRef.current) {
      getTabId('tabReverseLookup');
      isDefaultReverseViewRef.current = true;
      let urlParamsSearch =
        urlRef.current === ''
          ? new URLSearchParams()
          : // !update currenturl
          new URLSearchParams(new URL('', urlRef.current).search);

      const decodedParameters = new URLSearchParams(
        '?' +
        LZString.decompressFromEncodedURIComponent(urlParamsSearch.get('s')!)
      );

      decodedParameters.set('isDefaultReverseView', 'true');
      updateUrl(
        `${LZString.compressToEncodedURIComponent(decodedParameters.toString())}`
      );
    }
  }, [isNoCrossesFoundAtCompareTab]);

  useEffect(() => {
    // ! Check if has value at input when search
    if (gridApiRef.current && !inputError && !gridApiRef.current.destroyCalled) {
      setNumberOfResult(gridApiRef.current.getDisplayedRowCount());
    }
  });

  //Update pin column
  useEffect(() => {
    if (columnApiRef.current) {
      updateColPin(columnApiRef);
    }
  });

  //! Toggle Display Spinner
  useToggleDisplayForSpinner(isFetching);

  //Set source part cell
  useEffect(() => {
    sourcePartCellRef.current = document.querySelector(
      '.ag-row.ag-row-pinned > .ag-cell.ag-cell-not-inline-editing.ag-cell-normal-height.ag-cell-wrap-text.ag-cell-last-left-pinned > .ag-cell-wrapper > .ag-cell-value'
    );

    sourcePartCellMobileRef.current = document.querySelector(
      '.ag-floating-top-viewport > .ag-floating-top-container> div:first-child>div:first-child>.ag-cell-wrapper>.ag-cell-value'
    );

    let isNoDatasheet = false;
    if (searchedProduct) {
      isNoDatasheet =
        (searchedProduct[0].primaryDatasheetUrl === undefined ||
          searchedProduct[0].primaryDatasheetUrl === '') &&
        searchedProduct[0].rohsStatus !== 'Rohs3Compliant';
    }

    if ((!isNoProductFound && productDetail.length === 0) || isNoDatasheet) {
      // Set source part cell css
      const sourcePartCell = sourcePartCellRef.current;
      const sourcePartCellMobile = sourcePartCellMobileRef.current;

      if (sourcePartCell)
        sourcePartCell.style.marginLeft = isCompareProductsView
          ? '27px'
          : '25px';
      // Set source part cell css on mobile
      if (sourcePartCellMobile)
        sourcePartCellMobile.style.marginLeft = isCompareProductsView
          ? '27px'
          : '25px';
    }
  });

  //Update share link url for search request
  useEffect(() => {
    const urlUpdate = () => {
      let decodeParam = updateUrlUtil(
        urlRef.current,
        'searchRequest',
        JSON.stringify(searchRequest)
      );
      updateUrl(LZString.compressToEncodedURIComponent(decodeParam.toString()));
    };
    urlUpdate();
  }, [searchRequest]);

  //Update share link url for check box list
  useEffect(() => {
    const urlUpdate = () => {
      let decodeParam = updateUrlUtil(
        urlRef.current,
        'checkboxList',
        JSON.stringify(listCheckBox)
      );
      updateUrl(LZString.compressToEncodedURIComponent(decodeParam.toString()));
    };
    urlUpdate();
  }, [listCheckBox]);

  // ! UPDATED
  //Update URL
  const updateUrl = (suffixUrl: string) => {
    const baseUrl = window.location.origin + window.location.pathname + '?s=';
    const url = `${baseUrl}${suffixUrl}`;

    if (urlRef.current !== url) {
      urlRef.current = url;
      setCurrentUrl(url);
    }
  };

  // ! UPDATED
  // ! SHORT URL
  const shareBtnHandler = async () => {
    const pathname = window.location.pathname.split('/');
    const languageParam = pathname[1];
    const baseUrl = `${window.location.origin}/${languageParam}/cross-reference`;
    // ! check if input search not null
    if (wrapReturnStringForUnitTest(urlRef.current) && !inputError) {
      const resultShortUrl = await createShortUrl(urlRef.current);
      setShortUrl(`${baseUrl}/short/${resultShortUrl.id}`);

      toggleModal();
    } else {
      setShortUrl(baseUrl);

      toggleModal();
    }
  };

  // ! Filter column when at tab BasePart
  const filterColumnForTabBasePart = (tableColumns: any) => {
    if (tableColumns) {
      const tempCurrentColdDef = [
        ...tableColumns.filter(
          (item: any) =>
            item &&
            item.field &&
            !item.field.startsWith('pin') &&
            item.field !== 'crossType.crossName' &&
            item.field !== 'priceBreaksIncludeTariff'
        )
      ];
      if (screenWidth < 768) {
        const newColDefs = updateColDefsUniqueByFieldName(
          tempCurrentColdDef,
          COL_DEF_UN_SET_PINED_COL,
          'manufacturerProductNumber'
        );
        setOriginalBasePartCols(newColDefs);
      } else {
        const pinColumn = isReverse
          ? COL_DEF_SET_PINED_RIGHT_COL
          : COL_DEF_SET_PINED_LEFT_COL;
        const newColDefs = updateColDefsUniqueByFieldName(
          tempCurrentColdDef,
          pinColumn,
          'manufacturerProductNumber'
        );
        setOriginalBasePartCols(newColDefs);
      }
    }
  };

  const getPartData = async (
    searchQuery: string | null,
    manufacturerId: number,
    unitPrice: number,
    pimVariantNumber: string | '',
    calledFromUrl: boolean,
    productVariations?: IProductVariation[]
  ) => {
    let newTableData: any = [];
    let productDetails: IProductDetails;
    let multipleProducts: boolean = false;

    try {
      if (searchQuery) {
        //Reset search url
        let urlParamsSearch =
          urlRef.current === ''
            ? new URLSearchParams()
            : // !update currenturl
            new URLSearchParams(new URL('', urlRef.current).search);

        const decodedParameters = new URLSearchParams(
          '?' +
          LZString.decompressFromEncodedURIComponent(
            urlParamsSearch.get('s')!
          )
        );

        decodedParameters.set('part', searchQuery);
        decodedParameters.set('partSearch', searchQuery);

        //Reset compare view params if not called from URL
        if (!calledFromUrl) {
          decodedParameters.delete('filter');
          decodedParameters.delete('filterOrder');
          decodedParameters.delete('colId');
          decodedParameters.delete('sort');
          decodedParameters.delete('comparePartIds');
          decodedParameters.delete('isCompareView');
          decodedParameters.delete('partId');
          decodedParameters.delete('partUnitPrice');
          decodedParameters.delete('partPimNumber');
          decodedParameters.delete('partSearch');
          decodedParameters.delete('hideOrUnhide');
          decodedParameters.delete('duplicateHeaderParam');
          decodedParameters.delete('tabComparePinouts');
          decodedParameters.delete('havePinOuts');
          decodedParameters.delete('isOrderByColumn');
          decodedParameters.delete('colStages');
          decodedParameters.delete('isDefaultReverseView');
          decodedParameters.delete('isHorizontalView');
          decodedParameters.delete('selectedDataIds');
          decodedParameters.delete('numberOfResultAtCompareView');
          decodedParameters.delete('comparePartIdsFiltered');

          setPartIdURL(-1);
          setUnitPriceURL(-1);
          setPimNumberURL('');
        }

        await updateUrl(
          `${LZString.compressToEncodedURIComponent(decodedParameters.toString())}`
        );

        setIsMultipleProducts(false);
        // Set isNoCrossesFound value is false when clicking on search to avoid saving previous data
        setIsNoCrossesFound(false);

        if (langRef.current && siteRef.current) {
          //Get source part detail
          productDetails = await getProductDetails(
            searchQuery,
            userData.IsLoggedIn,
            langRef.current,
            siteRef.current,
            currRef.current,
            productVariations,
            manufacturerId
          );
          if (productDetails && productDetails.products) {
            // Only set the productDetail value once when clicking search button
            if (manufacturerId === -1) {
              setProductDetail([...productDetails.products]);
              if (productDetails.products.length >= 2) {
                setIsMultipleProducts(true);
                multipleProducts = true;
                setIsNoProductFound(false);
                setReverseSearchedProduct(null);
                setIsFetching(false);
              }
            }

            // ! BASEPART NUMBER STARTS
            // ! Check part no vendor and has BasePart or not
            if (
              productDetails.products[0].baseProductNumber &&
              !multipleProducts
            ) {
              setHaveBasePart(true);
            } else {
              setHaveBasePart(false);
            }

            // ! for pinout
            // ! Check part no vendor and has pinout or not
            if (productDetails.products[0].havePinOut && !multipleProducts) {
              setHavePinOuts(true);
            } else {
              setHavePinOuts(false);
            }

            // ! BASEPART NUMBER ENDS
            //Click on a product in list exact match

            if (manufacturerId > 0) {
              setIsMultipleProducts(false);
              //Move product clicked to top array
              let index: number = 0;
              let topProduct: ISubstitute[] = [];
              if (productDetails && productDetails.products) {
                // Get index of product in list productDetails
                index = productDetails.products.findIndex(
                  (x) =>
                    x?.manufacturer.id === manufacturerId &&
                    x?.unitPrice === unitPrice &&
                    x?.pimVariantNumber === pimVariantNumber
                );

                //Set source part as first variation
                const sourcePartData = chooseSourcePart(productDetails, index);
                if (sourcePartData) {
                  productDetails.products[index].productVariations.sort(
                    function (x, y) {
                      return x === sourcePartData
                        ? -1
                        : y === sourcePartData
                          ? 1
                          : 0;
                    }
                  );
                }

                // ! Check part has BasePart or not
                if (productDetails.products[index].baseProductNumber) {
                  setHaveBasePart(true);
                } else {
                  setHaveBasePart(false);
                }

                // ! for improve table
                // !check have pinout
                if (productDetails.products[index].havePinOut) {
                  setHavePinOuts(true);
                } else {
                  setHavePinOuts(false);
                }

                // Get list product pin top in the cross table
                topProduct = await convertSourcePartDetail(
                  productDetails,
                  index
                );
                if (topProduct) {
                  setSearchedProduct(topProduct);
                  setReverseSearchedProduct(topProduct);
                  setVendorName(topProduct[0].vendor?.value);
                }
              }

              // Get cross details
              //       1st
              newTableData = await getCrossData(
                productDetails.products[index].manufacturerProductNumber,
                manufacturerId,
                topProduct,
                productDetails.products,
                index
              );
            }

            //Validate if there are more than one product returns from API
            validateProducDetail(productDetails);

            // Get non Digikey Part
            setNonDigikeyProduct([...productDetails.products]);

            // Click search button
            if (manufacturerId === -1 && !multipleProducts) {
              let getSearchedProduct: ISubstitute[] =
                await convertSourcePartDetail(productDetails, 0);

              if (getSearchedProduct) {
                setSearchedProduct(getSearchedProduct);
                setReverseSearchedProduct(getSearchedProduct);
                setVendorName(getSearchedProduct[0].vendor?.value);
              }

              const mnfId =
                productDetails.products[0].productVariations[0].supplier.id;

              // Get cross details
              //2nd
              newTableData = await getCrossData(
                productDetails.products[0].manufacturerProductNumber,
                mnfId,
                getSearchedProduct,
                productDetails.products,
                0
              );
            }
            if (newTableData && newTableData.length > 0) {
              setIsNoProductFound(false);
              setIsNonDk(false);
            }
          } else {
            // const path = window.location.pathname;
            //search non DigiKey part cross
            setIsNonDk(true);

            const nonDkPart: ICrossPart = await getNonDKPartCross(
              searchQuery,
              langRef.current,
              siteRef.current
            );
            // if non DigiKey part cross exists
            if (nonDkPart && nonDkPart.substitutes?.length) {
              //create non DigiKey source part
              const nonDkSourcePart = [
                {
                  manufacturerProductNumber: searchQuery,
                  vendor: {
                    key: 1,
                    value: nonDkPart.sourceVendorName
                  },
                  crossType: {
                    crossName: SOURCE_PART,
                    crossDescription: '',
                    type: SOURCE_PART
                  },
                  quantityAvailable: 0,
                  manufacturerPublicQuantity: 0,
                  url: '',
                  type: NON_DIGIKEY
                }
              ];
              // Set table data as non DigiKey part's crosses
              setSearchedProduct(nonDkSourcePart);
              setReverseSearchedProduct(nonDkSourcePart);
              //Non DK Part: Get substitue of sourcePart depend on User logged in or not
              let substitutes;
              // ! fake userdata logged
              if (userData.IsLoggedIn) {
                // ! for basepart
                substitutes = await getAdditionalData(
                  nonDkPart.substitutes,
                  productDetail,
                  searchQuery,
                  manufacturerId,
                  0,
                  tabIdRef.current,
                  langRef.current,
                  siteRef.current,
                  currRef.current
                );

                if (tabIdRef.current === 'tabBasePart') {
                  const tableColumns = getColumns(
                    nonDkPart.substitutes,
                    productDetail,
                    tabIdRef.current,
                    columnDefs
                  );

                  filterColumnForTabBasePart(tableColumns);

                  tableTempBasePartRef.current = substitutes;
                  return substitutes;
                }
              } else {
                // ! for basepart
                substitutes = await getAdditionalDataUnLogged(
                  nonDkPart.substitutes,
                  productDetail,
                  0,
                  tabIdRef.current,
                  langRef.current,
                  siteRef.current,
                  currRef.current,
                  searchQuery,
                  manufacturerId
                );

                if (tabIdRef.current === 'tabBasePart') {
                  const tableColumns = getColumnsUnLogged(
                    nonDkPart.substitutes,
                    productDetail,
                    tabIdRef.current,
                    columnDefs
                  );
                  filterColumnForTabBasePart(tableColumns);

                  tableTempBasePartRef.current = substitutes;
                  return substitutes;
                }
              }

              //3rd
              newTableData = substitutes?.filter((item: any) => item !== null);
              //Non DK Part: Get Columns of table include column header and column affect depend on User logged in or not
              let columnTables;
              // ! for improve table
              // ! fake userdata logged
              if (userData.IsLoggedIn) {
                columnTables = getColumns(
                  substitutes,
                  nonDkSourcePart,
                  tabIdRef.current,
                  columnDefs
                );
              } else {
                columnTables = getColumnsUnLogged(
                  substitutes,
                  nonDkSourcePart,
                  tabIdRef.current,
                  columnDefs
                );
              }
              if (columnTables) {
                setColumns(
                  updateColDefs(
                    columnTables,
                    COL_DEF_SORT_FILTER_PARTSTATUS_ON
                  )
                );
              }

              //Reset UI
              setIsNoProductFound(false);
              setProductDetail([]);
            } else {
              setIsNoProductFound(true);
              setIsFetching(false);
              setIsNoResult(true);
            }
          }
        }
      }
    } catch (error) {
      setErrorState(error);
    }

    return newTableData;
  };

  // Get cross data
  const getCrossData = async (
    searchQuery: string,
    manufacturerId: number,
    getSearchedProduct: ISubstitute[],
    productDetail: IProductDetailById[],
    index: number
  ) => {
    let crossPartData: any = [];

    if (langRef.current && siteRef.current) {
      const crossDetails = await getCrossPartDetails(
        searchQuery,
        manufacturerId,
        langRef.current,
        siteRef.current
      );

      if (crossDetails.substitutes && crossDetails.substitutes.length > 0) {
        setIsNoCrossesFound(false);

        let substitutes;

        //! Fake userdata logged
        //! Get additional data for subtitues depend on User logged in or not
        if (userData.IsLoggedIn) {
          substitutes = await getAdditionalData(
            crossDetails.substitutes,
            productDetail,
            searchQuery,
            manufacturerId,
            index,
            tabIdRef.current,
            langRef.current,
            siteRef.current,
            currRef.current
          );

          if (tabIdRef.current === 'tabBasePart') {
            const tableColumns = getColumns(
              substitutes,
              getSearchedProduct,
              tabIdRef.current,
              columnDefs
            );

            filterColumnForTabBasePart(tableColumns);

            // !Filter part like source
            if (getSearchedProduct && substitutes.length > 1) {
              // ! This is source part id and it has same value at any element
              // ! getSearchedProduct only has one elemnt
              const sourcePartId =
                getSearchedProduct[0].productVariations[0]?.masterProductId;
              substitutes = substitutes.filter(
                (item: any) => item.productId !== sourcePartId
              );
              setHaveBasePart(true);
            }
            tableTempBasePartRef.current = substitutes;
            return substitutes;
          }
        } else {
          substitutes = await getAdditionalDataUnLogged(
            crossDetails.substitutes,
            productDetail,
            index,
            tabIdRef.current,
            langRef.current,
            siteRef.current,
            currRef.current,
            searchQuery,
            manufacturerId
          );

          if (tabIdRef.current === 'tabBasePart') {
            const tableColumns = getColumnsUnLogged(
              substitutes,
              getSearchedProduct,
              tabIdRef.current,
              columnDefs
            );

            filterColumnForTabBasePart(tableColumns);

            // !Filter part like source
            if (getSearchedProduct && substitutes.length > 1) {
              // ! This is source part id and it has same value at any element
              // ! getSearchedProduct only has one elemnt
              const sourcePartId =
                getSearchedProduct[0].productVariations[0]?.masterProductId;
              substitutes = substitutes.filter(
                (item: any) => item.productId !== sourcePartId
              );
              setHaveBasePart(true);
            }
            tableTempBasePartRef.current = substitutes;

            return substitutes;
          }
        }

        //Populate medialink
        let mediaPopulatedSubstitutes;
        if (
          tabIdRef.current !== 'tabBasePart' &&
          langRef.current &&
          siteRef.current
        ) {
          mediaPopulatedSubstitutes = await populateMediaLink(
            substitutes,
            getSearchedProduct[0].productVariations[0].productId,
            langRef.current,
            siteRef.current
          );
        }

        //Get columns definition of tables depend on User logged in or not
        let tableColumns;
        // ! fake userdata logged
        if (userData.IsLoggedIn) {
          tableColumns = getColumns(
            substitutes,
            getSearchedProduct,
            tabIdRef.current,
            columnDefs
          );
        } else {
          tableColumns = getColumnsUnLogged(
            substitutes,
            getSearchedProduct,
            tabIdRef.current,
            columnDefs
          );
        }

        if (tableColumns) {
          modifyUIAtComparePageHanlder(tableColumns);
        }

        //Remove null item
        if (mediaPopulatedSubstitutes && mediaPopulatedSubstitutes.length > 0) {
          crossPartData = mediaPopulatedSubstitutes?.filter(
            (item: any) => item !== null
          );
        }
      } else {
        // ! for marketplace part starts
        if (tabIdRef.current === 'tabBasePart') {
          let substitutesBasePartNoCross;
          let tableColumnsBasePartNoCross;
          if (userData.IsLoggedIn) {
            // ! for basepart
            substitutesBasePartNoCross = await getAdditionalData(
              [],
              productDetail,
              searchQuery,
              manufacturerId,
              index,
              tabIdRef.current,
              langRef.current,
              siteRef.current,
              currRef.current
            );

            tableColumnsBasePartNoCross = getColumns(
              substitutesBasePartNoCross,
              getSearchedProduct,
              tabIdRef.current,
              columnDefs
            );

            filterColumnForTabBasePart(tableColumnsBasePartNoCross);

            tableTempBasePartRef.current = substitutesBasePartNoCross;
            return substitutesBasePartNoCross;
          } else {
            substitutesBasePartNoCross = await getAdditionalDataUnLogged(
              [],
              productDetail,
              index,
              tabIdRef.current,
              langRef.current,
              siteRef.current,
              currRef.current,
              searchQuery,
              manufacturerId
            );

            tableColumnsBasePartNoCross = getColumnsUnLogged(
              substitutesBasePartNoCross,
              getSearchedProduct,
              tabIdRef.current,
              columnDefs
            );

            filterColumnForTabBasePart(tableColumnsBasePartNoCross);

            tableTempBasePartRef.current = substitutesBasePartNoCross;
            return substitutesBasePartNoCross;
          }

          //Get columns definition of tables depend on User logged in or not
        } else {
          setIsNoCrossesFound(true);
          setIsNoCrossesFoundAtCompareTab(true);
          setIsNoResult(true);

          //Setting up headers for table
          const searchPartParameters = await getHeadersOfParameters(
            productDetail,
            getSearchedProduct,
            tabIdRef.current
          );
          let searchPartColDefs: any[] = [];
          if (searchPartParameters) {
            const newColumns = [...columnDefs];

            searchPartParameters.forEach((item: any) => {
              const field: string = item.field;
              const headerName: string = item.headerName;
              const cellClassRules = null;
              const parameterId = item.parameterId;

              const header = addCellRenderForPinColumn(
                field,
                headerName,
                cellClassRules,
                parameterId,
                userData.IsLoggedIn
              );

              newColumns.push(header);
            })
            searchPartColDefs = columnDefs.concat(newColumns);
          }

          setCurrentColDefs(searchPartColDefs);
          //Update UI if searched part have only 1 param
          let objIndex = searchPartColDefs.findIndex(
            (obj) => obj.cellRenderer === 'dkPartNumberCellRenderer'
          );
          if (searchPartParameters.length <= 1) {
            searchPartColDefs[objIndex].minWidth = 370;
          } else {
            searchPartColDefs[objIndex].minWidth = 220;
          }

          setColumns(
            updateColDefs(
              searchPartColDefs,
              COL_DEF_SORT_FILTER_PARTSTATUS_ON
            )
          );
          //Set searched data for table
          crossPartData = getSearchedProduct;
          searchedProductTempref.current = getSearchedProduct;
          setSearchedProduct(null);
        }

        // ! for marketplace part ends
      }

      if (tabIdRef.current !== 'tabBasePart') {
        crossPartData = sortTableData(
          crossPartData,
          getSearchedProduct,
          tabIdRef.current
        );
        tableTempRef.current = await crossPartData;
        return crossPartData;
      }
    }
  };

  // !  update UI when in compare page
  const modifyUIAtComparePageHanlder = (tableColumns: any) => {
    setColumns(
      updateColDefs(
        tableColumns,
        COL_DEF_SORT_FILTER_PARTSTATUS_ON
      )
    );

    setOriginalTableCol(tableColumns);
  };

  // ! Fix bug duplicate cross
  useEffect(() => {
    if (
      tabIdRef.current === 'tabCompareAtt' ||
      tabIdRef.current === 'tabReverseLookup'
    ) {
      setcolumnDefsFilterGlobal(originalCompareCols);
    } else if (tabIdRef.current === 'tabBasePart') {
      setcolumnDefsFilterGlobal(originalBasePartCols);
    } else {
      setcolumnDefsFilterGlobal(originalPinOutsCols || originalPinOutsColsRef.current);
    }
  }, [originalCompareCols, originalBasePartCols, originalPinOutsCols, tabId]);

  // ! Use Backup DATA to show when change tab (improve load time)
  // ! To use when user is  not at compare page
  const setBackupDataWhenChangeTab = async (
    searchQuery: string,
    manufacturerId: number,
    unitPrice: number,
    pimVariantNumber: string,
    calledFromUrl: boolean
  ) => {
    let data;
    // ! Check tabId to use appropriate tables => table of basepart
    if (wrapReturnStringForUnitTest(tabIdRef.current) === 'tabBasePart') {
      //! Prevent show all part at compare page
      if (isCompareRef.current !== 'true') {
        // ! Check if has backup Data then don't call API
        if (tableTempBasePartRef.current?.length > 0) {
          setTableData(tableTempBasePartRef.current);
        } else {
          setIsFetching(true);
          data = await getPartData(
            searchQuery.toUpperCase(),
            manufacturerId,
            unitPrice,
            pimVariantNumber,
            calledFromUrl,
            productVariations
          );
          tableTempBasePartRef.current = data;
          setTableData(data);
          setIsFetching(false);
        }
      }

      setIsNoCrossesFound(false);
    }
    // ! Check tabId to use appropriate tables => table of Compare or Pinouts
    else {
      //! Prevent show all part at compare page
      if (isCompareRef.current !== 'true') {
        // ! Check if has backup Data then don't call API
        if (tableTempRef.current?.length > 0) {
          setTableData(tableTempRef.current);
        } else {
          setIsFetching(true);
          data = await getPartData(
            searchQuery.toUpperCase(),
            manufacturerId,
            unitPrice,
            pimVariantNumber,
            calledFromUrl,
            productVariations
          );
          data = defaultSortCrossTypeData(data, tabId);
          tableTempRef.current = data;
          setTableData(data);
          setIsFetching(false);
        }
      }
    }
  };

  //! Only run when change tab and set backup DATA and use it when back to old tab
  //! Only use at main page(not share page) expect when change tab case
  useEffect(() => {
    const getTableDataWhenChangeTab = async () => {
      const partId = idOfMoreVendor.current;

      const partUnitPrice = unitPriceOfMoreVendor.current;

      const partPimNumber = pimVariantNumberOfMoreVendor.current;

      // ! At share page don't run here
      // ! Check if api is called when search new part then don't run here and it will be runned next life cycle
      if (!isCallingApi.current) {
        if (wrapReturnStringForUnitTest(searchQueryRef.current)) {
          // ! For part has multi vedor
          if (
            partId &&
            partUnitPrice &&
            partPimNumber &&
            isCompareRef.current !== 'true'
          ) {
            setBackupDataWhenChangeTab(
              searchQueryRef.current,
              parseInt(partId),
              parseFloat(partUnitPrice),
              partPimNumber,
              true
            );
          }
          // ! For part has no vendor
          else {
            setBackupDataWhenChangeTab(
              searchQueryRef.current,
              -1,
              -1,
              '',
              true
            );
          }
        }
      }
    };
    if (!inputError) {
      getTableDataWhenChangeTab();
    }
  }, [tabId, checkFetchedUser]);


  // ! Get DATA when search by url
  useEffect(() => {
    const getTableData = async () => {
      let result: any;
      if (checkFetchedUser !== undefined) {
        //! Set table data if url has format ?search=partNumber
        if (
          !isCompareProductsView &&
          !isReturnToView &&
          !isClickProductHasMultiVendor
        ) {
          const urlSearchParams = new URLSearchParams(window.location.search);
          if (
            urlSearchParams.has('search') &&
            isSearchByUrl
          ) {
            const params = Array.from(urlSearchParams.entries());
            let partSearchUrl = params[0][1].trim();
            isDefaultReverseViewRef.current = true;
            setIsFetching(true);

            result = await getPartData(
              partSearchUrl.toUpperCase(),
              -1,
              -1,
              '',
              false
            );
            result = defaultSortCrossTypeData(result, tabIdRef.current);
            searchQueryRef.current = partSearchUrl.toUpperCase();
            setSearchQuery(partSearchUrl.toUpperCase());
            setTableData(result);
            tableTempRef.current = result;
            setIsFetching(false);
            setIsSearchByUrl(false);
          }
        }
      }
    };

    getTableData();
  }, [checkFetchedUser, isSearchByUrl]);

  const setErrorState = (err: any): void => {
    if (err) {
      utagContext.setRef('Error');
      callGTMAnalytics(utagData, 'Error');
      callFunctionDkView({ ...utagData, ...{ ref_page_event: 'Error' } });
      console.error(err);
      setIsFetching(false);
      setIsError(true);
    }
  };

  const onSearchClickHandler = (value: string) => {
    setTableData([]);
    setInputError('');
    //clear old reverse search
    setReverseResult('');
    setSearchRequest(resetSearchRequest({ ...searchRequest }));
    setListCheckbox([]);

    setIsError(false);
    setIsCompareProducts(false);
    setIsNoResult(false);
    isCompareRef.current = 'false';
    filterToReturnRef.current = '';
    appliedFiltersToReturnRef.current = '';
    pageNumberRef.current = 0;
    setTabId('tabCompareAtt');
    tabIdRef.current = 'tabCompareAtt';
    tableBasepartef.current = [];
    tableTempBasePartRef.current = [];
    tableTempRef.current = [];
    gridApiRef.current?.setFilterModel([]);
    setHaveBasePart(false);
    setHavePinOuts(false);
    // ! Reset params at extract ref when state
    idOfMoreVendor.current = '';
    unitPriceOfMoreVendor.current = '';
    pimVariantNumberOfMoreVendor.current = '';
    columnApiRef.current?.applyColumnState({
      defaultState: { sort: null }
    });
    setIsNoCrossesFoundAtCompareTab(false);
    searchedProductTempref.current = undefined;
    isDefaultReverseViewRef.current = true;
    setShowTabHeader(true);
    setIsCompareProductsView(false);
    setDefaultExactProd(0);
    //Reset filter and sort after share with url
    setSortCol('');
    setSortDirection('');
    setFilter('');
    setIsReturnToView(false);
    setIsClickProductHasMultiVendor(false);
    setIsOrderByColumn(false);
    setIsHorizontalView(false);
    setIsAddToList(false);
    setSelectedPartBeforeLogin([]);
    setSelectedData([]);
    setCompareProductIds([]);
    setIsTabCompareAtt(true);

    if (value) {
      searchQueryRef.current = value;
      inputError && setInputError('');
      if (searchTemp.toLowerCase() !== value.toLowerCase()) {
        setSearchTemp(value);
      }
      setSearchQuery(value.toUpperCase());

      // ! change part on url when search
      const pathname = window.location.pathname.split('/');
      const languageParam = pathname[1];
      const urlToSearch = `${window.location.origin
        }/${languageParam}/cross-reference?search=${encodeURIComponent(
          value.toUpperCase()
        )}`;

      window.history.replaceState(
        null,
        'DigiKey: Cross Reference Search',
        urlToSearch
      );

      // !
      setSortCol('');
      setSortDirection('');
      const getTableData = async () => {
        setIsFetching(true);
        isCallingApi.current = true;
        let result = await getPartData(value.toUpperCase(), -1, -1, '', false);
        if (result && result.length > 0) {
          result = defaultSortCrossTypeData(result, tabIdRef.current);
          setTableData(result);
          tableTempRef.current = result;
        }
        setIsFetching(false);
      };

      //reset filter
      setAppliedFilters([]);

      getTableData();
    } else {
      setInputError('Required!');
      setIsFetching(false);
      setNumberOfResult(0);
    }
  };

  // Click exact product
  const onExactProductClickHandler = (
    value: string,
    id: number,
    unitPrice: number,
    pimVariantNumber: string,
    productVariations?: IProductVariation[]
  ) => {
    setProductVariations(productVariations);
    setTableData([]);
    setInputError('');
    //clear old reverse search
    setReverseResult('');
    setSearchRequest(resetSearchRequest({ ...searchRequest }));
    setListCheckbox([]);

    isDefaultReverseViewRef.current = true;
    setIsError(false);
    setIsNoResult(false);
    setIsCompareProducts(false);
    setIsCompareProductsView(false);
    isCompareRef.current = 'false';
    filterToReturnRef.current = '';
    appliedFiltersToReturnRef.current = '';
    pageNumberRef.current = 0;
    setTabId('tabCompareAtt');
    tabIdRef.current = 'tabCompareAtt';
    tableBasepartef.current = [];
    tableTempBasePartRef.current = [];
    tableTempRef.current = [];
    setHaveBasePart(false);
    setHavePinOuts(false);
    setShowTabHeader(true);
    setDefaultExactProd(id);
    setIsClickProductHasMultiVendor(true);
    setIsNoCrossesFoundAtCompareTab(false);
    searchedProductTempref.current = undefined;

    //Reset filter and sort after share with url
    setSortCol('');
    setSortDirection('');
    setFilter('');
    setIsOrderByColumn(false);
    setIsHorizontalView(false);
    setIsAddToList(false)
    setSelectedPartBeforeLogin([]);
    setSelectedData([]);
    setCompareProductIds([]);
    setIsTabCompareAtt(true);

    let searchbtn =
      document
        .querySelector('#xref-search-btn')
        ?.getAttribute('ref_page_event') ?? '';
    if (searchbtn) {
      utagContext.setRef(searchbtn);
    }
    setIsReturnToView(false);
    if (value) {
      searchQueryRef.current = value;
      //Set URL params for clicked part
      let urlParamsClickedPart =
        currentUrl === ''
          ? new URLSearchParams()
          : new URLSearchParams(new URL('', currentUrl).search);
      const decodedParams = new URLSearchParams(
        '?' +
        LZString.decompressFromEncodedURIComponent(
          urlParamsClickedPart.get('s')!
        )
      );
      decodedParams.set('partId', id.toString());
      decodedParams.set('partUnitPrice', unitPrice.toString());
      decodedParams.set('partPimNumber', pimVariantNumber);
      decodedParams.set('productVariations', JSON.stringify(productVariations));
      decodedParams.delete('hideOrUnhide');
      decodedParams.delete('isDefaultReverseView');
      decodedParams.delete('duplicateHeaderParam');
      decodedParams.delete('filter');
      decodedParams.delete('filterOrder');
      decodedParams.delete('sort');
      decodedParams.delete('isOrderByColumn');
      decodedParams.delete('colStages');
      decodedParams.delete('isHorizontalView');
      decodedParams.delete('selectedDataIds');
      decodedParams.delete('numberOfResultAtCompareView');

      inputError && setInputError('');
      setSearchQuery(value.toUpperCase());
      setSortCol('');
      setSortDirection('');

      const getTableData = async () => {
        setIsFetching(true);
        isCallingApi.current = true;
        const result = await getPartData(
          value.toUpperCase(),
          id,
          unitPrice,
          pimVariantNumber,
          false,
          productVariations
        );

        //reset filter
        setAppliedFilters([]);
        if (result && result.length > 0) {
          setTableData(result);
          tableTempRef.current = result;
        }
        setIsFetching(false);
      };

      decodedParams.set('partId', id.toString());
      decodedParams.set('partUnitPrice', unitPrice.toString());
      decodedParams.set('partPimNumber', pimVariantNumber);

      // ! Get params by ref when state don't have
      idOfMoreVendor.current = id.toString();
      unitPriceOfMoreVendor.current = unitPrice.toString();
      pimVariantNumberOfMoreVendor.current = pimVariantNumber;

      decodedParams.delete('hideOrUnhide');
      decodedParams.delete('duplicateHeaderParam');
      decodedParams.delete('filter');
      decodedParams.delete('filterOrder');
      decodedParams.delete('tabId');
      decodedParams.delete('isOrderByColumn');
      decodedParams.delete('colStages');

      getTableData();

      updateUrl(
        `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
      );
    } else {
      setInputError('Required!');
      setIsFetching(false);
      setNumberOfResult(0);
    }
  };

  //Apply part option checkbox handler
  const applyOptionHandler = (isActivePartInclude: boolean) => {
    let urlParamsApplyOption =
      urlRef.current === ''
        ? new URLSearchParams()
        : // !update currenturl
        new URLSearchParams(new URL('', urlRef.current).search);

    const decodedParams = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(
        urlParamsApplyOption.get('s')!
      )
    );
    if (isActivePartInclude) {
      decodedParams.set('active', 'true');
    } else {
      decodedParams.set('active', 'false');
    }
    externalFilterChanged("activePartFilter", isActivePartInclude);
    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
    );

    setIsDisplayOptionApplied(isActivePartInclude);
    //Reset compare product if checkbox status changes
    setIsCompareProducts(false);
    setIsAddToList(false)
    setPinnedSelected(false);
    const pinnedDiv = document.getElementById('pinnedTopRow');
    pinnedDiv?.classList.remove('ag-checked');

    // ! for save state to local storage starts
    // ! available when user logged in
    if (userData.IsLoggedIn) {
      const keyState = `${userData.CustomerId}_${searchQueryRef.current}_${siteRef.current}_${langRef.current}`;
      createOrUpdateKeyState(keyState, 'isActiveChecked', isActivePartInclude);
    }
    // ! for save state to local storage ends
  };

  //Apply part option checkbox handler
  const applyMarketplaceHandler = async (isMarketplaceExclude: boolean) => {
    //Set up share URL
    let urlParamsApplyMarketPlace =
      urlRef.current === ''
        ? new URLSearchParams()
        : // !update currenturl
        new URLSearchParams(new URL('', urlRef.current).search);

    const decodedParams = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(
        urlParamsApplyMarketPlace.get('s')!
      )
    );
    if (isMarketplaceExclude) {
      decodedParams.set('marketplace', 'true');
    } else {
      decodedParams.set('marketplace', 'false');
    }
    externalFilterChanged("marketplaceFilter", isMarketplaceExclude);

    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
    );

    setIsMarketplaceApplied(isMarketplaceExclude);
    //Reset compare product if checkbox status changes
    setIsCompareProducts(false);
    setIsAddToList(false)
    setPinnedSelected(false);
    const pinnedDiv = document.getElementById('pinnedTopRow');
    pinnedDiv?.classList.remove('ag-checked');

    // ! for save state to local storage starts
    // ! available when user logged in
    if (userData.IsLoggedIn) {
      const keyState = `${userData.CustomerId}_${searchQueryRef.current}_${siteRef.current}_${langRef.current}`;
      createOrUpdateKeyState(
        keyState,
        'isMarketplaceChecked',
        isMarketplaceExclude
      );
    }
    // ! for save state to local storage ends
  };

  // function apply checkbox exclude tariff
  const applyExcludeTariffHandler = async (isExcludeUnitPriceTariff: boolean) => {
    //Set up share URL
    let urlParamsApplyExcludeTariff =
      urlRef.current === ''
        ? new URLSearchParams()
        : // !update currenturl
        new URLSearchParams(new URL('', urlRef.current).search);

    const decodedParams = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(
        urlParamsApplyExcludeTariff.get('s')!
      )
    );
    if (isExcludeUnitPriceTariff) {
      decodedParams.set('excludeTariffFilter', 'true');
    } else {
      decodedParams.set('excludeTariffFilter', 'false');
    }
    externalFilterChanged("excludeTariffFilter", isExcludeUnitPriceTariff);

    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
    );

    setIsExcludeTariffApplied(isExcludeUnitPriceTariff);
    //Reset compare product if checkbox status changes
    setIsCompareProducts(false);
    setIsAddToList(false);
    setPinnedSelected(false);
    const pinnedDiv = document.getElementById('pinnedTopRow');
    pinnedDiv?.classList.remove('ag-checked');

    // ! for save state to local storage starts
    // ! available when user logged in
    if (userData.IsLoggedIn) {
      const keyState = `${userData.CustomerId}_${searchQueryRef.current}_${siteRef.current}_${langRef.current}`;
      createOrUpdateKeyState(
        keyState,
        'isExcludeTariffChecked',
        isExcludeUnitPriceTariff
      );
    }
    // ! for save state to local storage ends
  };

  const applyStockingHandler = (isStockingOnly: boolean) => {
    //Set up share URL
    let urlParamsApplyStock =
      urlRef.current === ''
        ? new URLSearchParams()
        : // !update currenturl
        new URLSearchParams(new URL('', urlRef.current).search);

    const decodedParams = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(
        urlParamsApplyStock.get('s')!
      )
    );
    if (isStockingOnly) {
      decodedParams.set('stocking', 'true');
    } else {
      decodedParams.set('stocking', 'false');
    }
    externalFilterChanged("inStockingFilter", isStockingOnly);

    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
    );
    //Set state
    setIsStockingApplied(isStockingOnly);
    //Reset compare product if checkbox status changes
    setIsCompareProducts(false);
    setIsAddToList(false)
    setPinnedSelected(false);
    const pinnedDiv = document.getElementById('pinnedTopRow');
    pinnedDiv?.classList.remove('ag-checked');

    // ! for save state to local storage starts
    // ! available when user logged in
    if (userData.IsLoggedIn) {
      const keyState = `${userData.CustomerId}_${searchQueryRef.current}_${siteRef.current}_${langRef.current}`;
      createOrUpdateKeyState(keyState, 'isStockingChecked', isStockingOnly);
    }
    // ! for save state to local storage ends
  };

  // Update columns pinned
  const updateColPin = (columnApi: any) => {
    setTimeout(function () {
      if (window.innerWidth < 900) {
        // Unpin columns on small device
        columnApi.current.applyColumnState({
          defaultState: { pinned: null }
        });
      }
    });
  };

  // Event onGridReady
  const onGridReady = (params: any) => {
    columnApiRef.current = params.columnApi;
    gridApiRef.current = params.api;

    // Update columns pinned on event load grid
    updateColPin(columnApiRef);

    // Update columns pinned on event resize window
    window.addEventListener('resize', function () {
      updateColPin(columnApiRef);
    });
  };

  const onFirstDataRendered = (event: any) => {
    //Sort column if defined in URL
    if (sortCol && sortDirection) {
      event.columnApi.applyColumnState({
        state: [{ colId: sortCol, sort: sortDirection }],
        defaultState: { sort: null }
      });
    }
    if (filter) {
      let filteredObject;
      const filterModel = JSON.parse(filter);
      //get columns field default
      const columnDefault = columnDefs.filter(x => x.field !== "priceBreaksIncludeTariff").map(col => col.field);
      const columnFields = new Set(columnDefault);
      columnFields.add("partStatus");
      //exclude the items are paramters
      if (userData.IsLoggedIn) {
        filteredObject = filterModel;
      } else {
        filteredObject = Object.keys(filterModel)
          .filter(key => columnFields.has(key))
          .reduce((obj: any, key) => {
            obj[key] = filterModel[key];
            return obj;
          }, {});
      }
      if (Object.keys(filteredObject).length > 0) {
        event.api.setFilterModel(filteredObject);
      } else {
        setAppliedFilters([])
      }
    }
    //set table APIsetIsSaveState
    if (urlPageNumber !== 0) {
      event.api.paginationGoToPage(urlPageNumber);
      setURLPageNumber(0);
    }
    // ! for save state to local storage starts
    colStagesDefaultRef.current = event.columnApi.getColumnState();
    const keyState = `${userData.CustomerId}_${searchQueryRef.current}_${siteRef.current}_${langRef.current}`;
    const keyTabState = `${userData.CustomerId}_${searchQueryRef.current}_${tabIdRef.current}_${siteRef.current}_${langRef.current}`;
    restoreState(
      keyState,
      event.columnApi,
      urlRef.current,
      userData.IsLoggedIn,
      searchRequest,
      keyTabState,
      tabIdRef.current,
      setIsDisplayOptionApplied,
      setIsMarketplaceApplied,
      setIsExcludeTariffApplied,
      setIsStockingApplied,
      setIsUsingLocalStoraged,
      updateUrl,
      setSearchRequest,
      externalFilterChanged
    );
    // ! for save state to local storage ends

    // Load part user selected
    const selectedDataIds = selectedPartBeforeLogin?.length > 0 ? selectedPartBeforeLogin : isCompareRef.current === 'false' && selectedData;

    // Check if not use query string to get data
    if (!window.location.href.includes('/cross-reference?s=')) {
      // restore source part is selected from shorturl
      if (tabIdRef.current !== "tabReverseLookup") {
        const pinnedRow = gridApiRef.current.getPinnedTopRow(0);
        if (pinnedRow !== undefined && pinnedRow && pinnedRow.data && pinnedRow.data.productVariations) {
          const isSelected: boolean = selectedDataIds.some((item: any) => pinnedRow.data.productVariations.some((x: any) => x.productId === item.partID));
          setPinnedSelected(isSelected);
          const pinnedDiv = document.getElementById('pinnedTopRow');
          if (isSelected) {
            pinnedDiv?.classList.add('ag-checked');
          }
        }
      }
      restorePartSelected(selectedDataIds, event.api);
    }
    else {
      //restore source part is selected from compare page
      if (tabIdRef.current !== "tabReverseLookup") {
        const pinnedRow = gridApiRef.current?.getPinnedTopRow(0);
        if (pinnedRow) {
          const isSelected: boolean = pinnedRow.data.productVariations?.some((x: any) => compareProductIds?.includes(x.productId));
          setPinnedSelected(isSelected);
          const pinnedDiv = document.getElementById('pinnedTopRow');
          if (isSelected) {
            pinnedDiv?.classList.add('ag-checked');
          }
        }
      }
      restorePartSelectedWhenReturningFromComparePage(compareProductIds, event.api);
    }
  };

  // ! for save state to local storage starts
  const { onDragStarted, onDragStopped } = useDragColumnChange(
    `${userData.CustomerId}_${searchQueryRef.current}_${tabIdRef.current}_${siteRef.current}_${langRef.current}`,
    urlRef.current,
    updateUrl,
    setIsOrderByColumn,
    userData.IsLoggedIn
  );
  // ! for save state to local storage ends

  // update numberSelected, isCompareProducts, and url when click checkbox pinned top row
  useEffect(() => {
    if (gridApiRef.current && tabIdRef.current !== "tabReverseLookup") {
      //get node in normal rows
      const selectedNodes = gridApiRef.current.getSelectedNodes();
      //get node pinned row
      const pinnedNode = gridApiRef.current.getPinnedTopRow(0);
      //check if pinned row is selected then push node pinned row to selectedNodes
      const allSelectedNodes = pinnedSelected
        ? [...selectedNodes ?? [], pinnedNode]
        : [...selectedNodes ?? []];

      setNumberOfSelected(allSelectedNodes?.length ?? 0);
      if (!isCompareProductsView) {
        allSelectedNodes?.length >= 2
          ? setIsCompareProducts(true)
          : setIsCompareProducts(false);
      }
      allSelectedNodes?.length > 0
        ? setIsAddToList(true)
        : setIsAddToList(false);
      // Get selected part and update in share url
      setSelectedPartAndUpdateIntoUrl(allSelectedNodes, urlRef.current, updateUrl);
    }
  }, [pinnedSelected])

  //set pinnedSelected to onSelectionChanged get the value latest
  useEffect(() => {
    pinnedSelectedRef.current = pinnedSelected;
  }, [pinnedSelected])

  //On part selection change
  const onSelectionChanged = (event: any) => {
    gridApiRef.current = event.api;
    let selectedNodes = event.api.getSelectedNodes();
    //get node pinned row
    const pinnedNode = gridApiRef?.current.getPinnedTopRow(0);
    //check if pinned row is selected then push node pinned row to selectedNodes
    const isPinnedSelected = pinnedSelectedRef.current;
    selectedNodes = isPinnedSelected
      ? [...selectedNodes, pinnedNode]
      : [...selectedNodes];
    utagContext.setRef("Selected Box");
    setNumberOfSelected(selectedNodes.length);

    if (!isCompareProductsView) {
      selectedNodes.length >= 2
        ? setIsCompareProducts(true)
        : setIsCompareProducts(false);
    }

    selectedNodes.length > 0
      ? setIsAddToList(true)
      : setIsAddToList(false);

    // Get selected part and update in share url
    setSelectedPartAndUpdateIntoUrl(selectedNodes, urlRef.current, updateUrl);
  };

  //Compare product button
  const compareProductsBtnHandler = async () => {
    //Get selected data
    let selectedNodes = gridApiRef.current?.getSelectedNodes();
    let selectedData: ISubstitute[] = selectedNodes.map((node: any) => node.data);
    let pinnedProductIdCompared;
    const productIds: number[] = selectedData.map((a) => a.productIdCompared);
    //get pinned top row
    const pinnedTopRow = gridApiRef.current?.getPinnedTopRow(0).data;
    //get productVariables is marketplace
    const productVariationsmarketPlace = pinnedTopRow.productVariations?.filter((x:any)=>x.isMarketPlace)
    //Check if source part is selected then add sourcePart's productId to productIds array to compare
    if(pinnedSelected){
      if (productVariationsmarketPlace && productVariationsmarketPlace.length > 0) {
        pinnedProductIdCompared = productVariationsmarketPlace[0]?.productId;
      } else {
        pinnedProductIdCompared = pinnedTopRow?.productVariations[0]?.productId;
      }
      productIds.push(pinnedProductIdCompared);
    }

    // Redirect to compare page 
    redirectToComparePage(productIds, urlRef.current)

    //Get search params
    let urlParamsCompare = new URLSearchParams(
      new URL('', urlRef.current).search
    );
    //Get search params
    let comparebtn =
      document
        .querySelectorAll('.dk-btn__primary#compare-btn')[0]
        ?.getAttribute('ref_page_event') ?? '';
    if (comparebtn) {
      utagContext.setRef(comparebtn);
      callGTMAnalytics(utagData, comparebtn);
      callFunctionDkView({ ...utagData, ...{ ref_page_event: comparebtn } });
    }
    const decodedParams = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(urlParamsCompare.get('s')!)
    );

    // ! keep data when return
    const filterParam = wrapReturnStringForUnitTest(
      decodedParams.get('filter')
    );

    const filterOrder = wrapReturnStringForUnitTest(
      decodedParams.get('filterOrder')
    );

    const pageNumberInUrl = wrapReturnStringForUnitTest(
      decodedParams.get('pageNumber')
    );

    const isOrderByColumnParam = wrapReturnStringForUnitTest(
      decodedParams.get('isOrderByColumn')
    );

    if (pageNumberInUrl) {
      pageNumberRef.current = parseInt(pageNumberInUrl);
    } else {
      pageNumberRef.current = 0;
    }

    if (filterParam) {
      filterToReturnRef.current = filterParam;
    } else {
      filterToReturnRef.current = '';
    }

    if (filterOrder) {
      appliedFiltersToReturnRef.current = filterOrder;
    } else {
      appliedFiltersToReturnRef.current = '';
    }

    if (isOrderByColumnParam === 'true') {
      isOrderByColumnRef.current = true;
    }

    decodedParams.set('hideOrUnhide', 'false');
    decodedParams.delete('duplicateHeaderParam');
    //Delete sort in params

    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
    );
  };

  //On grid size changed
  const onGridSizeChanged = (event: any) => {
    setGridHeight(event.clientHeight);
  };

  // Handle sort Data
  const onSortChanged = () => {
    // TODO full url window.location.href
    const urlParamsSort = new URLSearchParams(
      new URL('', urlRef.current).search
    );
    const decodedParams = new URLSearchParams(
      '?' + LZString.decompressFromEncodedURIComponent(urlParamsSort.get('s')!)
    );

    let columnStates = columnApiRef.current.getColumnState();

    let sortCol = columnStates.filter((obj: any) => {
      return obj.sort !== null;
    })

    if (sortCol.length > 0) {
      decodedParams.set('colId', sortCol[0].colId);
      decodedParams.set('sort', sortCol[0].sort);
      if (userData.IsLoggedIn) {
        const keyState = `${userData.CustomerId}_${searchQueryRef.current}_${tabIdRef.current}_${siteRef.current}_${langRef.current}`;
        createOrUpdateKeyState(keyState, 'sortOrder', { colId: sortCol[0].colId, sort: sortCol[0].sort });
      }
    } else {
      decodedParams.delete('colId');
      decodedParams.delete('sort');
      if (userData.IsLoggedIn) {
        const keyState = `${userData.CustomerId}_${searchQueryRef.current}_${tabIdRef.current}_${siteRef.current}_${langRef.current}`;
        createOrUpdateKeyState(keyState, 'sortOrder', { sort: null });
      }
    }

    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
    );
  };

  const onPaginationChanged = (event: any) => {
    //set table API
    gridApiRef.current = event.api;

    //Get search params
    const urlParamsPagination = new URLSearchParams(
      new URL('', urlRef.current).search
    );

    const decodedParams = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(
        urlParamsPagination.get('s')!
      )
    );

    //Get page number
    let currentPageNumber = event.api.paginationGetCurrentPage();
    pageNumberToPinSourceRef.current = currentPageNumber;
    if (currentPageNumber !== 0) {
      decodedParams.set('pageNumber', currentPageNumber);
    } else {
      decodedParams.delete('pageNumber');
    }

    // ! Remove border redudant
    const redundantBorderLeft = document.querySelector(
      '[ref="topLeftContainer"]>.ag-row-even.ag-row-pinned.ag-row-level-0'
    );
    const redundantBorderRight = document.querySelector(
      '[ref="topCenterContainer"]>[ref="eContainer"]>.ag-row-even.ag-row-pinned.ag-row-level-0'
    );

    if (redundantBorderRight && redundantBorderLeft) {
      redundantBorderLeft.classList.add('borderNone');
      redundantBorderRight.classList.add('borderNone');
    }

    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
    );
  };

  // Get all applied filter
  const onFilterChanged = (event: any) => {
    gridApiRef.current = event.api;
    columnApiRef.current = event.columnApi;
    let tempAppliedFilters: string[] = [];
    let result: string[] = [];

    const path = window.location.pathname;
    const isAnyFilterPresent = event.api.isAnyFilterPresent();

    let urlParamsFilter: URLSearchParams;
    urlParamsFilter = new URLSearchParams(new URL('', urlRef.current).search); //shareUrl => currentUrl

    const decodedParams = new URLSearchParams(
      '?' +
      LZString.decompressFromEncodedURIComponent(urlParamsFilter.get('s')!)
    );

    if (isAnyFilterPresent) {
      const filterModel: { [key: string]: any } = event.api.getFilterModel();

      // ! Sort index filter (position of filters)
      for (var colId in filterModel) {
        tempAppliedFilters.push(
          event.columnApi.getColumn(colId).colDef.headerName
        );
      }

      if (appliedFiltersToReturnRef.current) {
        const temp = JSON.parse(appliedFiltersToReturnRef.current);

        tempAppliedFilters = tempAppliedFilters.sort(
          (a, b) => temp.indexOf(a) - temp.indexOf(b)
        );
      }

      // ! sort index filter at share page (position of filters)
      if (path.includes('/cross-reference/')) {
        tempAppliedFilters = tempAppliedFilters.sort(
          (a, b) => appliedFilters.indexOf(a) - appliedFilters.indexOf(b)
        );
      }

      if (
        appliedFilters.length >= 1 &&
        tempAppliedFilters.length >= appliedFilters.length
      ) {
        let newAddedFilter = tempAppliedFilters.filter(
          (x) => appliedFilters.indexOf(x) === -1
        );
        result = appliedFilters.concat(newAddedFilter);
        decodedParams.set('filterOrder', JSON.stringify(result));
        setAppliedFilters(result);
      } else if (
        appliedFilters.length >= 1 &&
        appliedFilters.length >= tempAppliedFilters.length
      ) {
        let removedFilter = appliedFilters.filter(
          (val) => !tempAppliedFilters.includes(val)
        );
        let filtersAfterRemoved = appliedFilters.filter(
          (e) => e !== removedFilter[0]
        );

        decodedParams.set('filterOrder', JSON.stringify(filtersAfterRemoved));
        setAppliedFilters(filtersAfterRemoved);
      } else {
        decodedParams.set('filterOrder', JSON.stringify(tempAppliedFilters));

        setAppliedFilters(tempAppliedFilters);
      }
      //Set applied filters
      decodedParams.set('filter', JSON.stringify(filterModel));
    } else {
      setAppliedFilters([]);
      //Delete sort in params
      decodedParams.delete('filter');
      decodedParams.delete('filterOrder');
    }

    updateUrl(
      `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
    );
  };
  //Reverse Search hook
  //Init reverse search request with category id
  useInitSearchQueryRequest(reverseSearchedProduct);
  //Result of reverse search & Query string for filtering product page
  useUpdateResultAndQueryString(searchRequest);

  const removeFilterHandler = (removeFilterName: string) => {
    if (columnApiRef.current && gridApiRef.current && !gridApiRef.current.destroyCalled) {
      const removedColumn = columnApiRef.current
        .getAllColumns()
        .find((column: any) => column.colDef.headerName === removeFilterName);
      gridApiRef.current.destroyFilter(removedColumn);
    }
  };

  const removeAllFilterHandler = () => {
    if (columnApiRef.current && gridApiRef.current && !gridApiRef.current.destroyCalled) {
      gridApiRef.current.setFilterModel(null);
      gridApiRef.current.onFilterChanged();

      filterToReturnRef.current = '';
      appliedFiltersToReturnRef.current = '';

      columnApiRef.current.resetColumnState();
    }
  };

  const getIsTariffActive = async () => {
    const result = await getTariffFunctionFlag();
    if (result && getLangSite('us').site === 'us') {
      setIsTariffActive(true);
    }
    return result;
  }

  useEffect(() => {
    getIsTariffActive();
  }, [])


  //Condition to run external filter
  const isExternalFilterPresent = useCallback(() => {
    return checkboxTypeRef.current.length > 0;
  }, []);

  //Add the checkboxes checked to checkboxTypeRef
  const externalFilterChanged = useCallback((newValue: string, isChecked: boolean) => {
    gridApiRef.current?.deselectAll();
    if (isChecked) {
      checkboxTypeRef.current = [...checkboxTypeRef.current, newValue];
    } else {
      checkboxTypeRef.current = checkboxTypeRef.current.filter(item => item !== newValue);
    }
    gridApiRef.current?.onFilterChanged();
  }, []);

  //filter the checkboxes based on Aggrid
  const doesExternalFilterPass = useCallback((node) => {
    if (!node.data) return false;

    return checkboxTypeRef.current.every((filter) => {
      switch (filter) {
        case "excludeTariffFilter":
          return !node.data?.productVariations?.some(
            (x: any) => x.priceBreaksIncludeTariff.length > 0
          );
        case "marketplaceFilter":
          return !node.data.isMarketPlace;
        case "inStockingFilter":
          return !(node.data.manufacturerPublicQuantity === 0 && node.data.quantityAvailable === 0) &&
            !(node.data.productVariations[0].quantityAvailable === 0 && node.data.isMarketPlace);
        case "activePartFilter":
          return node.data.parameters?.[0]?.['valueId'] === '0';
        default:
          return true;
      }
    });
  }, []);

  return (
    <>
      <CrossTitleFeedback searchQuery={searchQuery} />
      <ShareModal
        isOpen={isModalOpen}
        onClose={toggleModal}
        shortUrl={shortUrl}
      ></ShareModal>

      {isHasMyList ?
        (<BreadcrumbLists
          listId={listId}
          customerId={userData.CustomerId}
        >
        </BreadcrumbLists>) : null}
      <div className="dk-card p-2 mb-2">
        <div className="search-container" data-testid="top-search">
          <TopSearch
            inputError={inputError}
            isFetching={isFetching}
            searchText={searchQuery.toUpperCase()}
            isActiveChecked={isDisplayOptionApplied}
            isMarketplaceChecked={isMarketplaceApplied}
            isStockingChecked={isStockingApplied}
            isHasMyList={isHasMyList}
            isExcludeTariffChecked={isExcludeTariffApplied}

            onSearchClick={onSearchClickHandler}
            onApplyActive={applyOptionHandler}
            onApplyMarketplace={applyMarketplaceHandler}
            onApplyExcludeTariff={applyExcludeTariffHandler}
            onApplyStocking={applyStockingHandler}
            isTariffActive={isTariffActive}
            isTabCompareAtt={isTabCompareAtt}
          />

        </div>

        {searchQuery && (appliedFilters.length > 0 || isOrderByColumn) && (
          <AppliedFilter
            appliedFilters={appliedFilters}
            onRemoveFilter={removeFilterHandler}
            onRemoveAllFilter={removeAllFilterHandler}
            isOrderByColumn={isOrderByColumn}
            setIsOrderByColumn={setIsOrderByColumn}
            columnApi={columnApiRef.current}
            updateUrl={updateUrl}
            currentUrl={urlRef.current}
          ></AppliedFilter>
        )}
      </div>

      <BottomSearch
        inputError={inputError}
        numberOfResult={
          isNoCrossesFound || isNoProductFound ? 0 : numberOfResult
        }
        searchText={searchQuery.toUpperCase()}
        productDetail={productDetail}
        vendorName={vendorName}
        isMultipleProducts={isMultipleProducts}
        showTabHeader={showTabHeader}
        currentUrl={urlRef.current}
        isFetching={isFetching}
        isHasMyList={isHasMyList}
        shareBtnHandler={shareBtnHandler}
        getTabId={getTabId}
      />

      <WarningMessageContainer
        isError={isError}
        inputError={inputError}
        isNoProductFound={isNoProductFound}
        isNoCrossesFound={isNoCrossesFound}
        isFetching={isFetching}
        tabId={tabIdRef.current}
        isDefaultReverseView={isDefaultReverseViewRef.current}
      />

      {!isNoProductFound && searchQuery ? (
        <div>
          {productDetail && productDetail.length >= 2 && !inputError && (
            <div className="mt-2">
              <h2>{`${t('xref-exact-match')} ${searchQuery}`}</h2>
              <ExactMatch
                exactProduct={productDetail}
                nonDigikeyProduct={nonDigikeyProduct}
                defaultExactProd={defaultExactProd}
                onExactProductClick={onExactProductClickHandler}
                partIdURL={partIdURL}
                unitPriceURL={unitPriceURL}
                pimNumberUrl={pimNumberUrl}
              />
            </div>
          )}
          {!isMultipleProducts ? (
            <div className="">
              <div style={{ overflowX: 'auto' }}>
                <div id="table-data" className="table-container">
                  {!tableData || tableData.length === 0 ? null : (
                    <div className="table-title-and-function-for-table-container">
                      <div>
                        {(tabIdRef.current === 'tabReverseLookup' ||
                          isCompareRef.current === 'true') && (
                            <ToggleSwitch
                              isHorizontalView={isHorizontalView}
                              setIsHorizontalView={setIsHorizontalView}
                              updateUrl={updateUrl}
                              currentUrl={urlRef.current}
                              setIsAddToList={setIsAddToList}
                              setAppliedFilters={setAppliedFilters}
                            />
                          )}
                      </div>

                      <>
                        {tabIdRef.current !== 'tabReverseLookup' &&
                          tabIdRef.current !== 'tabComparePinouts' &&
                          isCompareRef.current !== 'true' &&
                          userData.IsLoggedIn && (
                            <ExportToExcel
                              gridApi={gridApiRef.current}
                              searchText={searchQuery.toUpperCase()}
                            />
                          )}
                      </>
                    </div>
                  )}

                  {/*//! for spinner statrs */}
                  {isFetching ? (
                    <div className="mb-5">
                      <SpinnerForTable />
                    </div>
                  ) : !tableData ||
                    tableData.length === 0 ? null :
                    tabIdRef.current !== 'tabReverseLookup' ? (
                      <div className="ag-theme-alpine">
                        <AgGridReact
                          rowData={
                            tableData
                          }
                          gridOptions={
                            userData.IsLoggedIn
                              ? { ...TOP_OPTIONS, ...gridOptionsLocale }
                              : {
                                ...TOP_OPTIONS_UNLOGGED,
                                ...gridOptionsLocale
                              }
                          }
                          columnDefs={columnDefsFilterGlobal}
                          frameworkComponents={frameworkComponents}
                          onGridReady={onGridReady}
                          onSelectionChanged={onSelectionChanged}
                          onGridSizeChanged={onGridSizeChanged}
                          onFilterChanged={onFilterChanged}
                          onSortChanged={onSortChanged}
                          onFirstDataRendered={onFirstDataRendered}
                          onPaginationChanged={onPaginationChanged}
                          suppressContextMenu={!userData.IsLoggedIn}
                          enableRtl={isReverse}
                          onDragStarted={(e: any) => {
                            utagContext.setRef('On Drag');
                            return onDragStarted(e);
                          }}
                          onDragStopped={onDragStopped}
                          pinnedTopRowData={searchedProduct}
                          excelStyles={EXECL_STYLE}
                          doesExternalFilterPass={doesExternalFilterPass}
                          isExternalFilterPresent={isExternalFilterPresent}
                        />
                      </div>
                    ) : (
                      // ! Add To List Ends *
                      reverseSearchedProduct && (
                        <ReverseAgTable
                          rowData={[
                            {
                              ...reverseSearchedProduct[0],
                              typeColumn: 'first-row'
                            },
                            {
                              ...reverseSearchedProduct[0],
                              typeColumn: 'second-row'
                            }
                          ]}
                          columnDefs={columnDefsFilterGlobal}
                          pinRowData={reverseSearchedProduct}
                          currentUrl={urlRef.current}
                          updateUrl={updateUrl}
                          onFirstDataRendered={onFirstDataRendered}
                          isReverse={isReverse}
                          setIsOrderByColumn={setIsOrderByColumn}
                          keyState={`${userData.CustomerId}_${searchQueryRef.current}_${tabIdRef.current}_${siteRef.current}_${langRef.current}`}
                          isOrderByColumn={isOrderByColumn}
                          isHorizontalView={isHorizontalView}
                        />
                      )
                    )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}

      {/* Compare and Add to list buttons Starts */}
      {!isHasMyList &&
        numberOfSelected > 0 &&
        tableData.length > 0 &&
        tabIdRef.current !== 'tabReverseLookup' && (
          <ActionWhenSelectPart
            gridApi={gridApiRef.current}
            currentUrl={urlRef.current}
            numberOfSelected={numberOfSelected}
            isCompareProducts={isCompareProducts}
            isAddToList={isAddToList}
            isReverse={isReverse}
            compareProductsBtnHandler={compareProductsBtnHandler}
          />
        )}

      {/* Compare and Add to list buttons action Ends */}

      {/* Add alternates part to list buttons Starts */}
      {isHasMyList &&
        numberOfSelected > 0 &&
        tableData.length > 0 &&
        tabIdRef.current === 'tabCompareAtt' && (
          <ActionWhenSelectPartHasMyList
            gridApi={gridApiRef.current}
            numberOfSelected={numberOfSelected}
            isAddToList={isAddToList}
            isReverse={isReverse}
            listId={listId}
            uniqueId={uniqueId}
            searchQuery={searchQuery}
          />
        )}

      {/* Add alternates part to list buttons Ends */}

      {/*//! for spinner ends */}

      <div className="introduction-info-container">
        {!searchQuery ? <Introduction /> : <></>}
        <AppInfo
          isTableDataExists={
            !tableData || tableData.length === 0 ? false : true
          }
          isErrorMessageShown={isNoCrossesFound || (isNoProductFound && !isFetching)}
        ></AppInfo>
      </div>
      <div className="bottom-feedback">
        <CrossTitleFeedback searchQuery={searchQuery} />
      </div>
      <Utag utagData={uTagData} />
    </>
  );
};

export default LandingPage;
